var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

class HeaderElement extends HTMLElement {
  constructor() {
    super();
    this.lastHeight = 0;
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    if (window.innerWidth <= 1100) return;

    this.headerOuter = this.querySelector('.header_wrapper');
    if (!this.headerOuter) return;

    this.resizeObserver = new ResizeObserver(() => {
      requestAnimationFrame(this.update);
    });

    this.resizeObserver.observe(this.headerOuter);
    requestAnimationFrame(this.update);
  }

  disconnectedCallback() {
    if (this.resizeObserver) this.resizeObserver.disconnect();
  }

  update() {
    if (!this.headerOuter) return;

    const newHeight = this.headerOuter.getBoundingClientRect().height;

    if (newHeight !== this.lastHeight) {
      this.lastHeight = newHeight;
      document.body.style.setProperty('--header-height', `${newHeight}px`);
    }
  }
}

if (!customElements.get('header-element')) {
  customElements.define('header-element', HeaderElement);
}

 class AnnouncementPromo extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const wrapper = this.querySelector('.swiper');
    const nextEl = this.querySelector('.swiper--next');
    const prevEl = this.querySelector('.swiper--prev');    
    
    if (!wrapper || wrapper.querySelectorAll('.swiper-slide').length <= 1) return;

    const slides = wrapper.querySelectorAll('.swiper-slide');

    let maxHeight = 0;
    slides.forEach(slide => {
      slide.style.height = 'auto'; 
      const height = slide.offsetHeight;
      if (height > maxHeight) maxHeight = height;
    });

    
  }
}
customElements.define('announcement-promo', AnnouncementPromo);


document.addEventListener("DOMContentLoaded", () => {
  const featuredTexts = document.querySelectorAll(".featured_text");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("text-visible");
        } else {
          entry.target.classList.remove("text-visible");
        }
      });
    },
    { threshold: 0.2 } // triggers when 20% of element is visible
  );

  featuredTexts.forEach((el) => observer.observe(el));
});


class CountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.getAttribute('data-section-id');
    this.endDateStr = this.querySelector('.countdown-timer__timer').getAttribute('data-end-date');
    this.intervalId = null;
  }

  connectedCallback() {
    // If no end-date is set, use 7 days from now
    if (!this.endDateStr) {
      const now = new Date();
      const future = new Date(now.getTime() + 7 * 24 * 60 * 60 * 1000);
      this.endDate = future;
    } else {
      this.endDate = new Date(this.endDateStr);
    }

    this.init();
  }

  init() {
    this.daysEl = this.querySelector('#days-' + this.sectionId);
    this.hoursEl = this.querySelector('#hours-' + this.sectionId);
    this.minutesEl = this.querySelector('#minutes-' + this.sectionId);
    this.secondsEl = this.querySelector('#seconds-' + this.sectionId);

    this.updateTimer();
    this.intervalId = setInterval(() => this.updateTimer(), 1000);
  }

  updateTimer() {
    const now = new Date();
    const timeRemaining = this.endDate - now;

    if (timeRemaining <= 0) {
      this.daysEl.textContent = '00';
      this.hoursEl.textContent = '00';
      this.minutesEl.textContent = '00';
      this.secondsEl.textContent = '00';
      clearInterval(this.intervalId);
      return;
    }

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor((timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((timeRemaining % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    this.daysEl.textContent = days.toString().padStart(2, '0');
    this.hoursEl.textContent = hours.toString().padStart(2, '0');
    this.minutesEl.textContent = minutes.toString().padStart(2, '0');
    this.secondsEl.textContent = seconds.toString().padStart(2, '0');
  }

  disconnectedCallback() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }
  }
}
customElements.define('countdown-timer', CountdownTimer);


class CountdownScroll extends HTMLElement {
  connectedCallback() {
    this.image = this.querySelector('.count_down_promo');
    this.section = this.closest('[id^="shopify-section-"]') || this;
    if (!this.image || !this.section) return;

    this.image.style.transition = 'transform 0.2s ease-out';
    this.image.style.transformOrigin = 'center';

    const update = () => {
      const rect = this.section.getBoundingClientRect();
      const winH = window.innerHeight;
      const visible = Math.max(0, Math.min(1, (winH - rect.top) / (rect.height + winH)));
      const rotate = visible * 25; // change 25 for max rotation
      this.image.style.transform = `rotate(${rotate}deg)`;
    };

    if (window.lenis && typeof window.lenis.on === 'function') {
      window.lenis.on('scroll', update);
    } else {
      window.addEventListener('scroll', update, { passive: true });
      window.addEventListener('resize', update);
    }
    update();
  }
}
customElements.define('countdown-scroll', CountdownScroll);


// FEATURED TAB
class FeaturedTab extends HTMLElement {
  constructor() {
    super();
    this.init();
  }

  init() {
    const tabButtons = this.querySelectorAll('.tab-button');
    const tabContents = this.querySelectorAll('.tab--content');
  
    tabButtons.forEach(button => {
      button.addEventListener('click', () => {
        const tabNum = button.getAttribute('data-tab').split('-')[1];
 
        tabButtons.forEach(btn => btn.classList.remove('active'));
        tabContents.forEach(content => {
          content.classList.remove('active');
          const btn = content.querySelector('a.btn');
          if(btn) {
            btn.setAttribute('tabIndex', '-1');
          }
        });

        button.classList.add('active');

        tabContents.forEach(content => {
          if (content.getAttribute('data-tab-show') === tabNum) {
            content.classList.add('active');
            const btn = content.querySelector('a.btn');
            if(btn) {
              btn.setAttribute('tabIndex', '0');
            }
          }
        });
      });
    });
  }
}
customElements.define('featured-tab', FeaturedTab);


class FaqList extends HTMLElement {
  constructor() {
    super();
    this.questions = this.querySelectorAll('.faq_list_head');
  }

  connectedCallback() {
    this.questions.forEach((question, index) => {
      const wrapper = question.closest('.faq-item-block_wrapper');
      const answer = wrapper.querySelector('.faq_list_content');
      const openIcon = question.querySelector('.open_drop');
      const closeIcon = question.querySelector('.close_drop');

      answer.style.transition = 'max-height 0.4s ease-in-out, opacity 0.4s ease-in-out';
      answer.style.overflow = 'hidden';
      answer.style.maxHeight = '0';
      answer.style.opacity = '0';

      question.addEventListener('click', () => {
        const isActive = answer.classList.contains('active');

        this.questions.forEach((q) => {
          const wrap = q.closest('.faq-item-block_wrapper');
          const ans = wrap.querySelector('.faq_list_content');
          const oIcon = q.querySelector('.open_drop');
          const cIcon = q.querySelector('.close_drop');

          oIcon.classList.add('hidden');
          cIcon.classList.remove('hidden');
          ans.classList.remove('active');
          ans.style.maxHeight = '0';
          ans.style.opacity = '0';
        });

        if (!isActive) {
          openIcon.classList.remove('hidden');
          closeIcon.classList.add('hidden');
          answer.classList.add('active');
          answer.style.maxHeight = `${answer.scrollHeight}px`;
          answer.style.opacity = '1';
        }
      });

      const btn = question.querySelector('button');
      if (btn) {
        btn.addEventListener('focusin', () => {
          answer.classList.add('active');
          answer.style.maxHeight = `${answer.scrollHeight}px`;
          answer.style.opacity = '1';
        });

        btn.addEventListener('focusout', () => {
          answer.classList.remove('active');
          answer.style.maxHeight = '0';
          answer.style.opacity = '0';
        });
      }

      if (index === 0) {
        openIcon.classList.remove('hidden');
        closeIcon.classList.add('hidden');
        answer.classList.add('active');
        answer.style.maxHeight = `${answer.scrollHeight}px`;
        answer.style.opacity = '1';
      }
    });
  }
}
customElements.define('faq-list', FaqList);


class FooterSection extends HTMLElement {
  constructor() {
    super();
    this.maxShift = 40;          
    this.animationZone = 50;    
  }

  connectedCallback() {
    window.addEventListener('scroll', this.onScroll.bind(this));
  }

  onScroll() {
    const scrollTop = window.scrollY;
    const docHeight = document.documentElement.scrollHeight;
    const winHeight = window.innerHeight;

    const distanceFromBottom = docHeight - (scrollTop + winHeight);

    const progress = Math.min(
      Math.max((this.animationZone - distanceFromBottom) / this.animationZone, 0),
      1
    );

    const shift = progress * this.maxShift;

    this.style.setProperty('--footer-shift', `${shift}px`);
  }
}
customElements.define('footer-section', FooterSection);


// PRODUCT CARD   
class ProductBlock extends HTMLElement {
  constructor() {
    super(); 
    this.slideGroups = [];
    this.colorOptions = [...this.querySelectorAll('.color_input')];
    this.mainLink = this.querySelector('[data-main-link]'); 
  }

  connectedCallback() {
    this.initImageSliders();
    this.bindColorSwatches();
    this.enableKeyboardVisualFocus();
  }

  initImageSliders() {
    const sliderContainers = [...this.querySelectorAll('.product_block_img.swiper')];
    if (!sliderContainers.length) return;

    sliderContainers.forEach((container) => {
      const swiperInstance = new Swiper(container, {
        speed: 600,
        slidesPerView: 1,
        spaceBetween: 0,
        a11y: false,
        navigation: {
          nextEl: ".next-button-product-block",
          prevEl: ".prev-button-product-block",
        },
      });

      this.slideGroups.push(swiperInstance);
    });
  }

  bindColorSwatches() {
    if (!this.colorOptions.length || !this.slideGroups.length) return;

    this.colorOptions.forEach((option) => {
      option.addEventListener("click", () => {
        const targetImage = option.dataset.variantImage;

        this.slideGroups.forEach((swiper) => {
          const index = [...swiper.slides].findIndex(
            (slide) => slide.dataset.src === targetImage
          );
          if (index !== -1) swiper.slideTo(index);
        });
      });  
    });
  }

  enableKeyboardVisualFocus() {
    if (!this.mainLink || !this.colorOptions.length) return;

    this.mainLink.addEventListener("focusin", (event) => {
      if (!event.target.matches(":focus-visible")) return;

      this.colorOptions.forEach((opt) => {
        opt.style.visibility = "visible";
      });
    });
  }
}
customElements.define("product-block", ProductBlock);



class SwiperSection extends HTMLElement {
  connectedCallback() {
    this.swiperEl = this.querySelector('.swiper');
    if (!this.swiperEl) return;

    this.waitForSwiper().then(() => this.init());
  }

  waitForSwiper() {
    return new Promise(resolve => {
      const check = () => {
        if (window.Swiper) return resolve();
        requestAnimationFrame(check);
      };
      check();
    });
  }

  init() {
    if (this.swiper) return;

    /* ---------- read dataset ---------- */
    this.slidesDesktop = Number(this.dataset.slidesDesktop) || 1;
    this.slidesTablet  = Number(this.dataset.slidesTablet)  || 1;
    this.slidesMobile  = Number(this.dataset.slidesMobile)  || 1;
    this.slidesPerGroup = Number(this.dataset.slidesGroup) || 1;
    this.offsetDesktop = Number(this.dataset.offsetDesktop) || 0;

    this.directionDesktop = this.dataset.slidesDirection || "horizontal";
    this.directionTablet  = this.dataset.directionTablet || "horizontal";
    this.directionMobile  = this.dataset.directionMobile || "horizontal";
    
    this.speed  = Number(this.dataset.speed) || 600;
    this.loop   = this.dataset.loop === 'true';
    this.freeMode = this.dataset.freeMode === 'true';
    this.effect = this.dataset.effect || 'slide';
    this.gap    = Number(this.dataset.gap) || 15;

    this.observeParents      = this.dataset.observeParents === 'true';
    this.autoHeight          = this.dataset.autoHeight === 'true';
    this.grabCursor          = this.dataset.grabCursor === 'true';
    this.watchSlidesProgress = this.dataset.progress === 'true';

    this.paginationEl   = this.querySelector('.swiper-pagination');
    this.paginationType = this.dataset.paginationType || 'bullets';

    this.autoplayEnabled =
      this.dataset.autoplay === 'true' || this.dataset.autoplay === '1';
    this.delay = Number(this.dataset.delay) || 3000;

    this.thumbsSelector = this.dataset.thumbs;

    /* ---------- thumbs handling ---------- */
    if (this.thumbsSelector) {
      const thumbsEl = document.querySelector(`.${this.thumbsSelector}`);
      if (thumbsEl) {
        const waitForThumbs = () => {
          if (thumbsEl.swiperInstance) {
            this.createSwiper(thumbsEl.swiperInstance);
          } else {
            requestAnimationFrame(waitForThumbs);
          }
        };
        waitForThumbs();
        return;
      }
    }

    /* ---------- no thumbs ---------- */
    this.createSwiper();
  }

  createSwiper(thumbsSwiper = null) {
    if (this.swiper) return;

    // Determine initial direction
    const getDirection = () => {
      const width = window.innerWidth;
      if (width >= 1024) return this.directionDesktop;
      if (width >= 769) return this.directionTablet;
      return this.directionMobile;
    };
   
    this.swiper = new Swiper(this.swiperEl, {
      slidesPerView: this.slidesMobile,
      spaceBetween: this.gap,
      slidesPerGroup: this.slidesPerGroup,
      direction: getDirection(),
      speed: this.speed,
      loop: this.loop,
      freeMode: this.freeMode,
      effect: this.effect,

      // 👇 default (mobile = 0 offset)
      slidesOffsetBefore: 0,

      observeParents: this.observeParents,
      autoHeight: this.autoHeight,
      grabCursor: this.grabCursor,
      watchSlidesProgress: this.watchSlidesProgress,

      breakpoints: {
        0:  { slidesPerView: this.slidesMobile, slidesPerGroup: 1 },
        769:  { slidesPerView: this.slidesTablet, slidesPerGroup: 1 },
        1024: { slidesPerView: this.slidesDesktop, slidesOffsetBefore: this.offsetDesktop }
      },

      ...(this.autoplayEnabled && {
        autoplay: {
          delay: this.delay,
          disableOnInteraction: false
        }
      }),

      ...(this.paginationEl && {
        pagination: {
          el: this.paginationEl,
          clickable: true,
          type: this.paginationType
        }
      }),

      ...(thumbsSwiper && {
        thumbs: {
          swiper: thumbsSwiper
        }
      }),

      navigation: {
        nextEl: this.querySelector('.swiper-button-next'),
        prevEl: this.querySelector('.swiper-button-prev')
      }
    });

    /* expose instance for thumbs linking */
    this.swiperEl.swiperInstance = this.swiper;

    // Responsive direction handling with smooth transition
    this.updateDirection = () => {
      const width = window.innerWidth;
      let newDirection = this.directionDesktop;
      if (width >= 769 && width < 1024) newDirection = this.directionTablet;
      else if (width < 769) newDirection = this.directionMobile;

      if (this.swiper && this.swiper.params.direction !== newDirection) {
        const currentIndex = this.swiper.activeIndex; // preserve current slide
        this.swiper.changeDirection(newDirection, false);
        this.swiper.slideTo(currentIndex, 0); // go back to the same slide
      }
    };

    this.updateDirection();
    window.addEventListener('resize', this.updateDirection);
  }

  disconnectedCallback() {
    if (!this.swiper) return;
    this.swiper.destroy(true, true);
    this.swiper = null;
    window.removeEventListener('resize', this.updateDirection);
  }
}

customElements.define('swiper-section', SwiperSection);



class CouponCode extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.input = this.querySelector("input");
    this.button = this.querySelector(".copy_btn");
    this.copiedText = this.button.querySelector('.tt');

    if (!this.input || !this.button) return;

    this.button.setAttribute("aria-live", "polite");
    this.button.setAttribute("aria-label", "Copy coupon code");
    this.button.setAttribute("role", "button");
    this.button.setAttribute("tabindex", "0");

    if (!this.querySelector(".sr-live")) {
      const live = document.createElement("span");
      live.className = "sr-live";
      live.setAttribute("aria-live", "polite");
      Object.assign(live.style, {
        position: "absolute",
        width: "1px",
        height: "1px",
        overflow: "hidden",
        clip: "rect(0 0 0 0)",
        whiteSpace: "nowrap"
      });
      this.appendChild(live);
      this.liveRegion = live;
    }

    this.button.addEventListener("click", () => this.copyCode());

    this.button.addEventListener("keydown", (event) => {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        this.copyCode();
      }
    });
  }

  copyCode() {
    if(this.copiedText) {
      this.copiedText.classList.add('visible');

      setTimeout(() => {
        this.copiedText.classList.remove('visible');
      },1000)
    }   

    navigator.clipboard.writeText(this.input.value).then(() => {
      this.button.classList.add("copied");
      this.liveRegion.textContent = "Coupon code copied";

      setTimeout(() => {
        this.button.classList.remove("copied");
      }, 200);
    });
  }
}
customElements.define("coupon-code", CouponCode);

class MobileMenuDrawer extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addAccordionListeners();
  }

  addAccordionListeners() {
    const toggles = this.querySelectorAll(".accordion-toggle button");
    toggles.forEach((button) => {
      button.addEventListener("click", () => {
        const toggle = button.closest(".accordion-toggle");
        const content = toggle?.nextElementSibling;
        const isOpen = toggle.classList.contains("active");
        const plus = toggle.querySelector?.(".plus_vertical");

        this.closeSiblings(toggle);

        if (content?.classList.contains("accordion-content")) {
          toggle.classList.toggle("active", !isOpen);
          content.classList.toggle("active", !isOpen);
          plus?.classList.toggle("rot", !isOpen);

          if (isOpen) {
            this.slideUp(content);
          } else {
            this.slideDown(content);
          }
        }
      });
    });
  }

  slideDown(el) {
    el.style.maxHeight = el.scrollHeight + "px";

    requestAnimationFrame(() => {
      const parentAccordion = el.closest(".main-accordion-content");
      if (parentAccordion) {
        parentAccordion.style.maxHeight =
          parentAccordion.scrollHeight + el.scrollHeight + "px";
      }
    });
  }

  slideUp(el) {
    el.style.maxHeight = "0";

    requestAnimationFrame(() => {
      const parentAccordion = el.closest(".accordion-content");
      if (parentAccordion && parentAccordion !== el) {
        parentAccordion.style.maxHeight = parentAccordion.scrollHeight + "px";
      }
    });
  }

  closeSiblings(currentToggle) {
    const parentWrapper =
      currentToggle.closest(".accordion-wrapper") ||
      currentToggle.parentElement.parentElement;

    const allToggles = parentWrapper.querySelectorAll(".accordion-toggle");

    allToggles.forEach((toggle) => {
      if (toggle === currentToggle) return;

      const content = toggle.nextElementSibling;

      if (content?.classList.contains("accordion-content")) {
        toggle.classList.remove("active");
        content.classList.remove("active");
        toggle.querySelector?.(".plus_vertical")?.classList.remove("rot");
        this.slideUp(content);
      }
    });
  }
}
customElements.define("menudrawer-mobile", MobileMenuDrawer);

const openBtns = document.querySelectorAll(".drawer_open_btn");
const closeBtns = document.querySelectorAll(".drawer_close_btn");
const drawers = document.querySelectorAll(".drawer-wrapper");

let lastFocusedButton = null;

drawers.forEach((drawer) => {
  const focusableElements = drawer.querySelectorAll("button, input:not([type='hidden']), a, select, textarea");
  focusableElements.forEach((el) => {
    el.setAttribute("tabindex", "-1");
  });
});

function closeAllDrawers() {
  drawers.forEach((drawer) => {
    drawer.classList.remove("active");
    drawer.classList.remove("content_fetched"); 
    drawer.setAttribute("aria-hidden", "true");
  });
}


function trapFocus(event, drawer) {
  const focusableElements = drawer.querySelectorAll("button, input:not([type='hidden']), a, select, textarea");
  const firstElement = focusableElements[0];
  const lastElement = focusableElements[focusableElements.length - 1];

  if (event.key === "Tab") {
    if (event.shiftKey && document.activeElement === firstElement) {
      event.preventDefault();
      lastElement.focus();
    } else if (!event.shiftKey && document.activeElement === lastElement) {
      event.preventDefault();
      firstElement.focus();
    }
  }
}

function lockBodyScroll() {
  const scrollBarWidth = window.innerWidth - document.documentElement.clientWidth;

  document.body.style.overflow = 'hidden';
  document.body.style.paddingRight = `15px`;
}

function unlockBodyScroll() {
  document.body.style.overflow = '';
  document.body.style.paddingRight = '';
}

function openDrawer(drawer, button, section) {
  closeAllDrawers();
  if (drawer) {
    if (!lastFocusedButton && button) {
      lastFocusedButton = button;
    }

    drawer.classList.add("active");
    drawer.removeAttribute('inert')
    drawer.setAttribute("aria-hidden", "false");
    document.body.classList.add("overflow-hidden");

    //  document.querySelector(".header_block").style.zIndex = "0";

    const focusableElements = drawer.querySelectorAll("button, input:not([type='hidden']), a, select, textarea");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "0");
    });

    if (focusableElements.length) {
      focusableElements[0].focus();
    }

    lenis.stop();
    lockBodyScroll();

    if(section) {
      section.style.zIndex = '9999';
    }

    drawer.addEventListener("keydown", (event) => trapFocus(event, drawer));
  }
}

function closeDrawer(drawer, section) {
  if (drawer) {
    drawer.classList.remove("active");
    drawer.setAttribute('inert', '');
    drawer.setAttribute("aria-hidden", "true");
    document.body.classList.remove("overflow-hidden");

    if (drawer.classList.contains("mobile_filter_drawer_wrapper")) {
      setTimeout(() => {
        document.querySelector(".header_block").style.zIndex = "4";
      }, 200);
    } else if(drawer.classList.contains('quick-view-wrapper')) {
     const placeholderTemplate = document.getElementById('quick-view-drawer_placeholder_template');
     const contentWrapper = drawer.querySelector('.quick-view-main-inner');

      if (placeholderTemplate && contentWrapper) {
        contentWrapper.innerHTML = placeholderTemplate.innerHTML;
      }
    }

    const focusableElements = drawer.querySelectorAll("input, button, a");
    focusableElements.forEach((el) => {
      el.setAttribute("tabindex", "-1");
    });

    const anyDrawerOpen = document.querySelector(".drawer-wrapper.active");

    if (!anyDrawerOpen && lastFocusedButton) {
      lastFocusedButton.focus();
      lastFocusedButton = null; // reset AFTER final close
    }

    if(section) {
      section.style.zIndex = '0'
    }

    lenis.start();
    unlockBodyScroll();
  }
}

function initDrawerOpenButtons() {
  const openBtns = document.querySelectorAll('[data-drawer]');

  openBtns.forEach((button) => {
    if (!button.hasAttribute('data-drawer-initialized')) {
      button.setAttribute('data-drawer-initialized', 'true'); // prevent duplicate listeners

      button.addEventListener("click", async (event) => {
        event.preventDefault();
        const drawerId = button.getAttribute("data-drawer");
        const drawer = document.getElementById(drawerId);      
        const rootSection = drawer.dataset.rootSection === 'true';
        const section = document.querySelector('.main-product-section');
        
        if (drawer) {
          if(rootSection && section) {
            openDrawer(drawer, button, section);
            lockBodyScroll();
          } else {
            openDrawer(drawer, button);
            lockBodyScroll();
          }                  
        }
      });
    }
  });
}

document.addEventListener("DOMContentLoaded", initDrawerOpenButtons);
document.addEventListener("shopify:section:load", initDrawerOpenButtons);
document.addEventListener("shopify:section:unload", initDrawerOpenButtons);
document.addEventListener('collection-grid-update', initDrawerOpenButtons);


function bindDrawerCloseButtons() {
  document.querySelectorAll('.drawer_close_btn').forEach((button) => {
    if (button.dataset.closeInitialized) return; // avoid rebinding
    button.dataset.closeInitialized = "true";

    button.addEventListener("click", () => {
      const drawer = button.closest(".drawer-wrapper");
      const section = document.querySelector('.main-product-section');
      if(section) {
        closeDrawer(drawer, section);
        unlockBodyScroll();
      } else {
        closeDrawer(drawer);
        unlockBodyScroll();
      }      
    });
  });
}

document.addEventListener("DOMContentLoaded", bindDrawerCloseButtons);
document.addEventListener("shopify:section:load", bindDrawerCloseButtons);


drawers.forEach((drawer) => {
  drawer.addEventListener("click", (event) => {
    const section = document.querySelector('.main-product-section');
    if (event.target === drawer) {
      if(section) {
        closeDrawer(drawer, section);
        unlockBodyScroll();
      } else {
        closeDrawer(drawer);
        unlockBodyScroll();
      }      
    }
  });

  drawer.addEventListener("keydown", (event) => {
    const section = document.querySelector('.main-product-section');
    if (event.key === "Escape") {
      if(section) {
        closeDrawer(drawer, section);
        unlockBodyScroll();
      } else {
        closeDrawer(drawer);
        unlockBodyScroll();
      }      
    }
  });

  const Inner = drawer.querySelector(".drawer-wrapper_inner");

});

class ProgressScroll extends HTMLElement {
  constructor() {
    super();
    this.bar = null;
    this.update = this.update.bind(this);
  }

  connectedCallback() {
    this.bar = this.querySelector(".progress_bar_scroll");
    if (!this.bar) return;

    requestAnimationFrame(() => {
      this.update();
      this.bar.style.opacity = "1";
    });

    window.addEventListener("scroll", this.update, { passive: true });
  }

  update() {
    if (!this.bar) return;

    const scrollTop = window.scrollY;
    const maxScroll =
      document.documentElement.scrollHeight - window.innerHeight;

    const progress = maxScroll > 0 ? (scrollTop / maxScroll) * 100 : 0;

    const newWidth = progress.toFixed(1) + "%";
    if (this.bar.dataset.last !== newWidth) {
      this.bar.dataset.last = newWidth;
      this.bar.style.setProperty("--width", newWidth);
    }
  }

  disconnectedCallback() {
    window.removeEventListener("scroll", this.update);
  }
}

customElements.define("progress-scroll", ProgressScroll);

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".shopify-section").forEach(section => {
    section.style.opacity = "1";
  });
});

setTimeout(() => {
  document.querySelectorAll(".shopify-section").forEach(section => {
    section.style.opacity = "1";
  });
}, 2000);


function debounce(fn, delay) {
  let timer;
  return (...args) => {
    clearTimeout(timer);
    timer = setTimeout(() => fn.apply(this, args), delay);
  };
}

// COLLECTION SORTING
class CollectionSorting extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form#main_collection_sorting_form');
    this.select = this.querySelector('select[name="sort_by"]');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.select.addEventListener('change', () => {
      const value = this.select.value;

      this.showLoader();

      const url = new URL(window.location.href, window.location.origin);
      url.searchParams.set('sort_by', value);
      url.searchParams.set('sections', this.sectionId);

      this.updatePage(url, this.sectionId);     

      this.updateURL(url);
    }) 
  }

  showLoader() {
    const loader = document.querySelector('.main_collection_grid_wrapper .loader');

    if(loader) {
      loader.classList.remove('hidden');
    }

    this.select.disabled = true;
  }

  hideLoader() {
    const loader = document.querySelector('.main_collection_grid_wrapper .loader');

    if(loader) {
      loader.classList.add('hidden');
    }

    this.select.disabled = false;
  }

  updatePage(url, id) {
    fetch(url.toString())
    .then((res) => res.json())
    .then((htmlString) => {
      const temp = document.createElement('div');
      temp.innerHTML = htmlString[id];
      const newWrapper = temp.querySelector('.main_collection_main_inner');
      const oldWrapper = document.querySelector('.main_collection_main_inner');

      if(oldWrapper && newWrapper) {
        oldWrapper.innerHTML = newWrapper.innerHTML
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: {
            url: url,
            sectionId: this.sectionId
          }
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err)
    })
    .finally(() => {
      this.hideLoader();
    })
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    window.history.pushState({}, '', url.toString())
  }
}

customElements.define('collection-sorting', CollectionSorting);


// COLLECTION FILTERS
class CollectionFilters extends HTMLElement {
  constructor() {
    super();
    this.inputs = this.querySelectorAll('input[type="checkbox"]');
    this.sectionId = this.dataset.sectionId;
    this.select = document.querySelector('select[name="sort_by"]');
    this.activeValues = this.querySelectorAll('.active_values_wrapper a');
    this.priceRanges = this.querySelectorAll('input[type="number"]');
  }

  connectedCallback() {
    if(this.inputs.length) {
      this.inputs.forEach((input) => {
        input.addEventListener('change', (e) => {

          this.showLoader();
          
          const url = e.currentTarget.checked ? new URL(e.currentTarget.dataset.addUrl, window.location.origin) : new URL(e.currentTarget.dataset.removeUrl, window.location.origin);

          url.searchParams.set('sections', this.sectionId);

          this.updatePage(url, this.sectionId);
          this.updateURL(url);
        })
      })
    }

    if(this.priceRanges.length) {
      this.priceRanges.forEach((priceRange) => {
        priceRange.addEventListener('input', debounce(() => {
          this.showLoader();

          const minInput = this.querySelector(`input[name="${priceRange.name.includes('gte') ? priceRange.name : priceRange.name.replace('lte', 'gte')}"]`);
          const maxInput = this.querySelector(`input[name="${priceRange.name.includes('lte') ? priceRange.name : priceRange.name.replace('gte', 'lte')}"]`);

          const minVal = minInput ? minInput.value : '';
          const maxVal = maxInput ? maxInput.value : '';

          const url = new URL(window.location.href);

          if (minVal) {
            url.searchParams.set(minInput.name, minVal);
          } else {
            url.searchParams.delete(minInput?.name);
          }

          if (maxVal) {
            url.searchParams.set(maxInput.name, maxVal);
          } else {
            url.searchParams.delete(maxInput?.name);
          }

          url.searchParams.set('sections', this.sectionId);

          this.updatePage(url, this.sectionId);
          this.updateURL(url);
        }, 1000))
      })
    }

    if(this.activeValues.length) {
      this.activeValues.forEach((activeValue) => {
        activeValue.addEventListener('click', (e) => {
          e.preventDefault();

          this.showLoader();

          const url = new URL(e.currentTarget.getAttribute('href'), window.location.origin);

          url.searchParams.set('sections', this.sectionId);

          this.updatePage(url, this.sectionId);
          this.updateURL(url);
        })
      })
    }
  }

  showLoader() {
    const loader = document.querySelector('.main_collection_grid_wrapper .loader');
    if(loader) {
      loader.classList.remove('hidden');
    }

    if(this.select) {
      this.select.disabled = true;
    }
  }

  hideLoader() {
    const loader = document.querySelector('.main_collection_grid_wrapper .loader');
    if(loader) {
      loader.classList.add('hidden');
    }

    if(this.select) {
      this.select.disabled = false;
    }
  }

  updatePage(url, id) {
    fetch(url.toString())
    .then((res) => res.json())
    .then((htmlString) => {
      const temp = document.createElement('div');
      temp.innerHTML = htmlString[id];

      const newWrapper = temp.querySelector('.main_collection_main_inner');
      const oldWrapper = document.querySelector('.main_collection_main_inner');

      if(oldWrapper && newWrapper) {
        oldWrapper.innerHTML = newWrapper.innerHTML
      }

      const newCount = temp.querySelector('.collection_products_count');
      const oldCount = document.querySelector('.collection_products_count');

      if(oldCount && newCount) {
        oldCount.innerHTML = newCount.innerHTML;
      }

      const newMobileDrawer = temp.querySelector('.mobile_filter_drawer');
      const oldMobileDrawer = document.querySelector('.mobile_filter_drawer');

      if(oldMobileDrawer && newMobileDrawer) {
        oldMobileDrawer.innerHTML = newMobileDrawer.innerHTML;
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: {
            url: url,
            sectionId: this.sectionId
          }
        })
      )

    })
    .catch((err) => {
      console.error('Error: ', err)
    })
    .finally(() => {
      this.hideLoader();
    })
  }

  updateURL(url) {
    url.searchParams.delete('sections');
    window.history.pushState({}, '', url.toString());
  }
}

customElements.define('collection-filters', CollectionFilters);


// INFINITE SCROLL
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    if (!this.button) return;

    this.button.addEventListener('click', () => {
      this.loadProducts();
    });
  }

  loadProducts() {
    const nextUrl = this.button.dataset.nextUrl;
    if (!nextUrl) return;

    this.showLoader();

    const url = new URL(nextUrl, window.location.origin);
    url.searchParams.set('sections', this.sectionId);

    this.updatePage(url, this.sectionId)    
  }

  updatePage(url, id) {
  fetch(url.toString())
    .then((res) => res.json())
    .then((htmlString) => {
      const temp = document.createElement('div');
      temp.innerHTML = htmlString[id];

      const oldGrid = document.querySelector('.main_collection_grid_inner');
      const newGrid = temp.querySelector('.main_collection_grid_inner');

      if (!oldGrid || !newGrid) return;

      const newItems = newGrid.querySelectorAll('product-card');

      if (!newItems.length) {
        this.button.remove(); // no more products
        return;
      }

      newItems.forEach((item) => {
        oldGrid.appendChild(item);
      });

      // UPDATE COUNT
      const newInfiniteCount = temp.querySelector('.infinite_scroll_products_count_wrapper');
      const oldInfiniteCount = document.querySelector('.infinite_scroll_products_count_wrapper');
      console.log(newInfiniteCount)

      if (oldInfiniteCount && newInfiniteCount) {
        oldInfiniteCount.innerHTML = newInfiniteCount.innerHTML;
      }


      /* UPDATE NEXT PAGE URL */
      const newButton = temp.querySelector('infinite-scroll button');
      if (newButton && newButton?.dataset.nextUrl) {        
        this.button.dataset.nextUrl  = newButton.dataset.nextUrl;
      } else {
        this.button.remove(); // last page
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: {
            url,
            sectionId: this.sectionId
          }
        })
      );
    })
    .catch((err) => console.error(err))
    .finally(() => {
      this.hideLoader();
    });
  }

  showLoader() {
    this.button.querySelector('.load_more')?.classList.add('hidden');
    this.button.querySelector('.pagination_loading')?.classList.remove('hidden');
  }

  hideLoader() {
    this.button.querySelector('.load_more')?.classList.remove('hidden');
    this.button.querySelector('.pagination_loading')?.classList.add('hidden');
  }
}

customElements.define('infinite-scroll', InfiniteScroll);


// MOBILE FILTERS
class MobileFilters extends HTMLElement {
  constructor() {
    super();
    this.loader = document.querySelector('.main_collection_grid_wrapper .loader');
    this.collectionGrid = document.querySelector('.main_collection_main_inner');
    this.btn = this.querySelector('.mobile_filters_btn button');
    this.form = this.querySelector('form#mobile_filters_form');
    this.drawer = document.querySelector('.mobile_filter_drawer');
    this.activeValues = this.querySelectorAll('.mob_active_values_wrapper a');
    this.sectionId = this.dataset.sectionId;
  }

  connectedCallback() {
    this.attachListeners();
  }

  attachListeners() {
    if(this.btn) {
      this.btn.addEventListener('click', (e) => {
        e.preventDefault();
        if(!this.form || !this.collectionGrid) return;

        this.showLoader();
        this.submitForm();
      })
    }    

    if(this.activeValues.length) {
    this.activeValues.forEach((value) => {
      value.addEventListener('click', (e) => {
        e.preventDefault();

        this.showLoader();

        const url = new URL(e.currentTarget.getAttribute('href'), window.location.href);

        this.updateURL(url.toString()),
        this.updatePage(url.toString(), this.sectionId);

      })
    })
  }
  }

  showLoader() {
    const loader = document.querySelector('.main_collection_grid_wrapper .loader');
    if(loader) {
      loader.classList.remove('hidden');
    }

    if(this.select) {
      this.select.disabled = true;
    }
  }

  hideLoader() {
    const loader = document.querySelector('.main_collection_grid_wrapper .loader');
    if(loader) {
      loader.classList.add('hidden');
    }

    if(this.select) {
      this.select.disabled = false;
    }
  }

  async submitForm() {
    const formData = new FormData(this.form);

    const priceGte = this.form.querySelector('[name="filter.v.price.gte"]');
    const priceLte = this.form.querySelector('[name="filter.v.price.lte"]');

    const defaultMin = priceGte?.getAttribute("data-default");
    const defaultMax = priceLte?.getAttribute("data-default");

    if (priceGte && priceLte && defaultMin && defaultMax) {
      if (priceGte.value === defaultMin && priceLte.value === defaultMax) {      
        priceGte.value = "";
        priceLte.value = "";

        formData.delete("filter.v.price.gte");
        formData.delete("filter.v.price.lte");
      }
    }

    const params = new URLSearchParams();

    const currentParams = new URLSearchParams(window.location.search);
    const hasSortBy = formData.has('sort_by');

    for(const [key, value] of currentParams.entries()) {
      if(!key.startsWith('filter.v.') && !key.startsWith('filter.p.')) {
        if(key === 'sort_by' && hasSortBy) {
          continue;
        }
        params.append(key,  value);
      }
    }

    for(const [key, value] of formData.entries()) {
      if(value && value != "") {
        if(key === "sort_by") {
          params.set(key, value);
        } else {
          params.append(key, value);
        }
      }
    }

    const url = `${window.location.pathname}?${params.toString()}`;

    await this.updateURL(url);
    await this.updatePage(url, this.sectionId);
  }  

  async updateURL(url) {
    history.pushState(null, "", url);
  }

  async updatePage(url, id) {
    const newURL = url.includes('?')
  ? `${url}&sections=${id}`
  : `${url}?sections=${id}`;
    
    fetch(newURL)
    .then((res) => res.json())
    .then((htmlString) => {

      const temp = document.createElement('div');
      temp.innerHTML = htmlString[id];

      const newWrapper = temp.querySelector('.main_collection_main_inner');
      const oldWrapper = document.querySelector('.main_collection_main_inner');

      if(oldWrapper && newWrapper) {
        oldWrapper.innerHTML = newWrapper.innerHTML
      }

      const newCount = temp.querySelector('.collection_products_count');
      const oldCount = document.querySelector('.collection_products_count');

      if(oldCount && newCount) {
        oldCount.innerHTML = newCount.innerHTML;
      }

      const newMobileDrawer = temp.querySelector('.mobile_filter_drawer');
      const oldMobileDrawer = this.drawer;

      if(oldMobileDrawer && newMobileDrawer) {
        oldMobileDrawer.innerHTML = newMobileDrawer.innerHTML;
      }

      document.dispatchEvent(
        new CustomEvent('collection-grid-update', {
          detail: {
            url: url,
            sectionId: this.sectionId
          }
        })
      )

    })
    .finally(() => {
      closeDrawer(this.drawer);
    })
  }

}

customElements.define('mobile-filters', MobileFilters);


// SEARCH RESET BUTTON
class SearchResetButton extends HTMLElement {
  constructor() {
    super();
    this.form = this.closest('form[role="search"]');
    this.btn = this.querySelector('.button_reset');    
  }

  connectedCallback() {
    this.btn.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();
    const url = new URL(window.location.href);
    url.search = '';
    window.location.href = url.toString();
  }
}

customElements.define('search-reset-button', SearchResetButton);


// LOCALIZATION FORM
class LocalizationForm extends HTMLElement {
  constructor() {
    super();

    this.currencyForm = this.querySelector('#currency_selector_form');
    this.languageForm = this.querySelector('#language_selector_form');

    this.currencyBtns = this.querySelectorAll('.currency_list button');
    this.languageBtns = this.querySelectorAll('.language_list button');
  }

  connectedCallback() {
    if(this.currencyBtns.length) {
      this.currencyBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleCurrencyClick.bind(this));
      })
    }

    if(this.languageBtns.length) {
      this.languageBtns.forEach((btn) => {
        btn.addEventListener('click', this.handleLanguageClick.bind(this));
      })
    }    
  }

  handleCurrencyClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="country_code"]').value = value;
    return;
    this.currencyForm.submit();
  }

  handleLanguageClick(e) {
    const value = e.currentTarget.dataset.value;
    this.querySelector('input[name="language_code"]').value = value;
    return;
    this.languageForm.submit();
  }
}

customElements.define('localization-form', LocalizationForm);


// SEARCH DRAWER
class SearchDrawer extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="text"]');
    this.reset = this.querySelector('.search_drawer_reset');
    this.emptyWrapper = this.querySelector('.empty_search_drawer');
    this.resultWrapper = this.querySelector('.result_search_drawer');
    this.resultInner = this.resultWrapper.querySelector('.result_search_inner');
  }

  connectedCallback() {
    if (this.input) {
      this.input.addEventListener('input', this.debounce(this.handleInput.bind(this), 300));
    }
    this.reset?.addEventListener('click', this.handleReset.bind(this));

    this.input.addEventListener("keydown", (e) => {
      if (e.key === "Enter") {
        e.preventDefault();

        const q = this.input.value.trim();
        if (q.length > 0) {
          window.location.href = `${window.Shopify.routes.root}search?q=${encodeURIComponent(q)}&options[prefix]=last`;
        }
      }
    });
  }

  debounce(fn, delay) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), delay);
    };
  }  

  handleReset(e) {
    e.preventDefault();
    this.input.value = "";
    this.showEmpty(true);
  }

  handleInput() {
    const q = this.input.value.trim();
    if (q.length === 0) {
      this.showEmpty(true);
      return;
    }

    fetch(`${window.Shopify.routes.root}search/suggest.json?q=${q}&resources[type]=product,collection,article,page`)
      .then(res => res.json())
      .then(data => this.renderResults(data.resources.results))
      .catch(err => console.error('Error fetching results:', err));
  }

  showEmpty(state) {
    this.emptyWrapper.style.display = state ? "flex" : "none";
    this.resultWrapper.style.display = state ? "none" : "block";
  }

  renderResults(results) {
    const { products = [], collections = [], articles = [], pages = [], queries = [] } = results;

    this.showEmpty(false);
    this.resultInner.innerHTML = "";

    const addGroup = (title, html) => {
      const wrap = document.createElement('div');
      wrap.classList.add('search_group');
      wrap.innerHTML = `<h6>${title}</h6>${html}`;
      this.resultInner.appendChild(wrap);
    };

    if (queries.length) {
      addGroup("Suggestions", queries.map(q => `
        <div class="query_card">
          <p><a href="${q.url}" aria-label="${q.text}">${q.styled_text}</a></p>
        </div>
      `).join(""));
    }

    if (collections.length) {
      addGroup("Collections", collections.map(c => `
        <div class="search_result_collection_card">
          <p><a href="${c.url}" aria-label="${c.title}">${c.title}</a></p>
        </div>
      `).join(""));
    }

    if (products.length) {
      addGroup("Products", products.map(p => `
        <div class="search_result_product_card">
          <div class="search_result_product_card_img ratio" style="--aspect-ratio: 100%;">
            <a href="${p.url}" aria-label="${p.title}"><img src="${p.featured_image?.url}" alt="${p.title}"></a>
          </div>
          <div class="search_result_product_card_info">
            <p><a href="${p.url}" aria-label="${p.title}">${p.title}</a></p>
            <div class="search_result_product_price">
              <span>${Shopify.formatMoney(p.price_min)}</span>
              ${p.compare_at_price_min > p.price_min ? `<s>${Shopify.formatMoney(p.compare_at_price_min)}</s>` : ""}
            </div>
          </div>
        </div>
      `).join(""));
    }

    if (articles.length) {
      addGroup("Articles", articles.map(a => `
        <div class="search_result_article_card">
          <div class="search_result_article_card_img ratio" style="--aspect-ratio: 100%;">
            <a href="${a.url}" aria-label="${a.title}"><img src="${a.image}" alt="${a.title}"></a>
          </div>
          <div class="search_result_article_info">
            <p>${a.title}</p>
            <a href="${a.url}" aria-label="${a.title}">Read More</a>
          </div>
        </div>
      `).join(""));
    }

    if (pages.length) {
      addGroup("Pages", pages.map(pg => `
        <div class="search_result_page_card">
          <p><a href="${pg.url}" aria-label="${pg.title}">${pg.title}</a></p>
        </div>
      `).join(""));
    }

    if (!queries.length && !collections.length && !products.length && !articles.length && !pages.length) {
      this.resultInner.innerHTML = `<h6 class="empty_results_heading">No results found matching your query.</h6>`;
    }
  }
}

customElements.define('search-drawer', SearchDrawer);


// VARIANT PICKER
class VariantPicker extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    this.addEventListener('change', (e) => {
      this.selectedOptions = this.getSelectedOptions;
      
      this.dispatchEvent(
        new CustomEvent('variant-change', {
          detail: {
            selectedOptions: this.selectedOptions
          },
          bubbles: true
        })
      )
    })
  }

  get getSelectedOptions() {
      const selectValues = Array.from(this.querySelectorAll('select')).map((select) => {
        return select.selectedOptions[0].dataset.value;
      })

      const radioValues = Array.from(this.querySelectorAll('input[type="radio"]:checked')).map((input) => {
        return input.dataset.value;
      })

      return [...selectValues, ...radioValues];
  }
}

customElements.define('variant-picker', VariantPicker);


// QUANTITY PICKER
class QuantityPicker extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('[data-minus]');
    this.input = this.querySelector('input[type="text"]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.value = Number(this.input.value); 
    this.step = Number(this.input.getAttribute('step')) || 1;
    this.min = this.input.dataset.min || 1;
    this.max = this.input.dataset.max;
  }

  connectedCallback() {
    this.minusBtn.addEventListener('click', this.handleChange.bind(this));
    this.plusBtn.addEventListener('click', this.handleChange.bind(this));
    const debouncedInputandler = this._debounce((e) => this.handleInput(e), 1000)
    this.input.addEventListener('input', debouncedInputandler);
  }

  handleChange(e) {
    if(e.currentTarget.hasAttribute('data-plus')) {
      this.value = this.value + this.step;
      this.input.value = this.value;
    } else {
      this.value = this.value - this.step;
      this.input.value = this.value;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }
    
    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    this.dispatchEvent(
      new CustomEvent('quantity-change', {
        detail: {
          value: this.value
        },
        bubbles: true
      })
    )    
  }

  handleInput(e) {
    this.value = Number(this.input.value);
    if(this.value == 0) {
      this.value = 1;
      this.input.value = 1;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }

    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    this.dispatchEvent(
      new CustomEvent('quantity-change', {
        detail: {
          value: this.value
        },
        bubbles: true
      })
    ) 

  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('quantity-picker', QuantityPicker);

// MAIN PRODUCT
class MainProduct extends HTMLElement {
  constructor() {
    super();
    this.originalSectionId = this.dataset.originalSectionId;
    this.sectionId = this.dataset.sectionId;
    this.productUrl = this.dataset.productUrl;
    this.isMainProduct = this.dataset.mainProduct;
    this.btn = this.querySelector('.product_form_submit_button');
    this.baseUrl = this.dataset.baseUrl;
    this.rootSection = this.closest('.main-product-section');
  }

  connectedCallback() {
    this.addEventListener('variant-change', this.onVariantChange.bind(this));
    this.addEventListener('quantity-change', this.onQuantityChange.bind(this));
  }

  onQuantityChange(e) {
    const value = e.detail.value;
    const baseInput = this.querySelector('input[name="quantity"]');
    if(baseInput) {
      baseInput.value = value;
    }    
  }

  onVariantChange(e) {
    const selectedOptions = e.detail.selectedOptions;
    
    this.requestURL = this.buildURL(selectedOptions);
    
    this.loadInfo(this.requestURL);
  }

  buildURL(options) {
    const params = [];
    if(options.length) {
      params.push(`option_values=${options.join(',')}`);
    }

    if(this.isMainProduct != 'true') {
      return `${this.productUrl}?section_id=${this.sectionId}&${params.join('&')}`;
    } else {
      return `${this.productUrl}?${params.join('&')}`;
    }    
  }

  loadInfo(url) {
    fetch(url)
    .then((res) => res.text())
    .then((htmlString) => {
      const html = new DOMParser().parseFromString(htmlString, 'text/html');
      this.updateContent(html);
    })
  }

  updateContent(html) {    
    const originalSectionId = this.dataset.originalSectionId;
    const container = html.querySelector('main-product');

    if(this.sectionId.includes('quick-add')) {
      const newSectionId = `quick-add-${originalSectionId}`;  
      console.log(newSectionId, originalSectionId);
      console.log(html);
      
      if(!container) return;

      container.innerHTML = container.innerHTML.replaceAll(originalSectionId, newSectionId);
    }

    container.dataset.sectionId = this.sectionId;

    // UPDATE PRICE
    const oldPrice = this.querySelector(`#Price-${this.sectionId}`);
    const newPrice = html.querySelector(`#Price-${this.sectionId}`);

    if(oldPrice && newPrice) {
      oldPrice.innerHTML = newPrice.innerHTML;
    }

    // UPDATE SKU
    const oldSKU = this.querySelector(`#SKU-${this.sectionId}`)
    const newSKU = html.querySelector(`#SKU-${this.sectionId}`)

    if(oldSKU && newSKU) {
      oldSKU.innerHTML = newSKU.innerHTML;
    }

    // UPDATE VARIANT PICKER
    const oldVariantPicker = this.querySelector(`#Variant_picker-${this.sectionId}`);
    const newVariantPicker = html.querySelector(`#Variant_picker-${this.sectionId}`);

    if(oldVariantPicker && newVariantPicker) {
      oldVariantPicker.innerHTML = newVariantPicker.innerHTML;
    }

    // UPDATE INVENTORY
    const oldInventory = this.querySelector(`#Inventory-${this.sectionId}`);
    const newInventory = html.querySelector(`#Inventory-${this.sectionId}`);

    if(oldInventory && newInventory) {
      oldInventory.innerHTML = newInventory.innerHTML;
    }

    // UPDATE QUANTITY
    const oldQuantity = this.querySelector(`#Quantity-${this.sectionId}`);
    const newQuantity = html.querySelector(`#Quantity-${this.sectionId}`);

    if(oldQuantity && newQuantity) {
      oldQuantity.innerHTML = newQuantity.innerHTML;
    }

    // UPDATE PICKUP AVAILABILITY
    const oldPickup = this.querySelector(`#Pickup-${this.sectionId}`);
    const newPickup = html.querySelector(`#Pickup-${this.sectionId}`);

    if(newPickup && oldPickup) {
      oldPickup.innerHTML = newPickup.innerHTML;
    }

    // UPDATE ADD TO CART BUTTON
    const oldBtn = this.querySelector('product-form');
    const newBtn = html.querySelector('product-form');

    if(oldBtn && newBtn) {
      oldBtn.innerHTML = newBtn.innerHTML;
    }

    // UPDATE FEATURED MEDIA
    const oldFeaturedMedia = this.querySelector(`#FeaturedMedia-${this.sectionId}`);
    const newFeaturedMedia = html.querySelector(`#FeaturedMedia-${this.sectionId}`);

    if(oldFeaturedMedia && newFeaturedMedia) {
      oldFeaturedMedia.innerHTML = newFeaturedMedia.innerHTML;
    }

    // UPDATE MOBILE MEDIA
    const oldMedia = this.querySelector('.product_media_mobile_wrapper');
    const newMedia = html.querySelector('.product_media_mobile_wrapper');

    if(oldMedia && newMedia) {
      oldMedia.innerHTML = newMedia.innerHTML;
    }

    if(this.dataset.updateUrl === 'true') {
      this.updateURL(html);
    }    

    this.setMainInput(html);
  }
  
  extractVariantData(html) {
    const data = this.querySelector('[data-selected-variant]').innerHTML;
    if(!data) return;

    return JSON.parse(data);
  }

  updateURL(html) {
    const variantData = this.extractVariantData(html);
    if(!variantData) return;

    window.history.replaceState(null, {}, `${this.productUrl}?variant=${variantData.id}`);

    this.handlePickup(variantData.id);
  }

  handlePickup(id) {
    let baseUrl = this.dataset.baseUrl;
    if(!baseUrl.endsWith('/')) {
      baseUrl = baseUrl + '/';
    }

    fetch(`${baseUrl}variants/${id}/?section_id=pickup-availability-section`)
    .then((res) => res.text())
    .then((data) => {
      const container = document.querySelector('[data-store-availability-container]');
      const newHTML = new DOMParser().parseFromString(data, 'text/html').querySelector('.pickup_availability_wrapper');

      if(container && newHTML) {
        container.innerHTML = newHTML.innerHTML;
        const pickUpDrawer = container.querySelector('pickup-availability-drawer');
        const pickUpBtn = container.querySelector('.pickup_info_btn');
        
        if(pickUpDrawer && pickUpBtn) {
          pickUpBtn.addEventListener('click', () => {
            openDrawer(pickUpDrawer, pickUpBtn, this.rootSection);
            
          })
        }

        if(pickUpDrawer) {
          pickUpDrawer.addEventListener('click', () => {
            closeDrawer(pickUpDrawer, this.rootSection);            
          })
        }
      }
    })

  }

  setMainInput(html) {
    const variantData = this.extractVariantData(html);
    if(!variantData) return;

    this.querySelector('input[name="id"]').value = variantData.id;
  }
}

customElements.define('main-product', MainProduct);


// PRODUCT FORM
class ProductForm extends HTMLElement {
  constructor() {
    super();

    this.handleSubmit = this.handleSubmit.bind(this);
    this.onVariantChange = this.onVariantChange.bind(this);
  }

  connectedCallback() {
    this.cacheElements();

    // Delegate submit handling to the component
    this.addEventListener('submit', this.handleSubmit);
    this.addEventListener('variant-change', this.onVariantChange);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.handleSubmit);
    this.removeEventListener('variant-change', this.onVariantChange);
  }

  cacheElements() {
    this.form = this.querySelector('form');
    this.button = this.querySelector('.product_form_submit_button');
    this.btnText = this.button?.querySelector('.btn_text');
    this.loader = this.button?.querySelector('.loader');
    this.cart = document.querySelector('cart-contents');
    this.openDrawer = false;
  }

  onVariantChange() {
    // Form was replaced → refresh references only
    this.cacheElements();
  }

  async handleSubmit(e) {
    // Make sure this submit belongs to OUR form
    if (!e.target.closest('form')) return;

    e.preventDefault();
    e.stopPropagation();

    this.cacheElements();
    if (!this.form || !this.button) return;

    this.btnText.style.visibility = 'hidden';
    this.loader.classList.remove('hidden');

    try {
      const formData = new FormData(this.form);

      const res = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      });

      const data = await res.json();
      if (!res.ok) {
        this.showError(data);
        const sections = await fetch(
          `${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`
        ).then(r => r.json());

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: { sections },
            bubbles: true
          })
        );
        throw data;
      }

      if (this.cart) {
        const sections = await fetch(
          `${Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`
        ).then(r => r.json());

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: { sections },
            bubbles: true
          })
        );

        this.openDrawer = true;
      } else {
        window.location.href = `${Shopify.routes.root}cart`;
      }

    } catch (err) {
      this.showError(err);
    } finally {
      this.btnText.style.visibility = 'visible';
      this.loader.classList.add('hidden');

      if (this.openDrawer && this.cart) {
        const drawer = this.cart.querySelector('.cart_drawer_wrapper');
        openDrawer(drawer, this.button);
      }
    }
  }   

  showError(data) {
    const error = this.querySelector('.product_add_error');
    if (!error) return;

    let message = 'Unable to add product to cart';

    if (data?.errors && typeof data.errors === 'object') {
      const formattedErrors = [];

      Object.entries(data.errors).forEach(([field, value]) => {
        let fieldLabel = '';

        // Human-friendly field names
        if (field === 'email') fieldLabel = 'Email';

        // Normalize message
        if (value === "can't be blank") {
          formattedErrors.push(`${fieldLabel} can't be blank`);
        } 
        else if (value === 'is invalid') {
          formattedErrors.push(`${fieldLabel} is invalid`);
        } 
        else {
          formattedErrors.push(`${fieldLabel} ${value}`);
        }
      });

      message = formattedErrors.join('<br>');
    }
    else if (typeof data?.errors === 'string') {
      message = data.errors;
    }
    else if (typeof data?.description === 'string') {
      message = data.description;
    }
    else if (typeof data?.message === 'string') {
      message = data.message;
    }

    error.innerHTML = message;
    error.classList.remove('hidden');
  }
}

customElements.define('product-form', ProductForm);


// RELATED PRODUCTS
class RelatedProducts extends HTMLElement {
  constructor() {
    super();
    this.productId = this.dataset.productId;
    this.sectionId = this.dataset.sectionId;
    this.recommendedURL = this.dataset.url;
    this.spacing = this.dataset.spacing;
    this.columns = this.dataset.columns;
    this.mobColumns = this.dataset.mobileColumns;    
    this.type = this.dataset.type || 'related';

    this.observer = new IntersectionObserver(this.handleObserver, {
      rootMargin: "0px 0px 500px 0px",
    }); 
  } 

   connectedCallback() {
    this.observer.observe(this);
  }

  disconnectedCallback() {
    this.observer.disconnect();
  }

   handleObserver = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.observer.disconnect(); 
        requestAnimationFrame(() => {
          this.loadRecommendedProducts(
            this.recommendedURL,
            this.productId,
            this.sectionId
          );
        });
      }
    });
  };

  loadRecommendedProducts(recommendedURL, productId, sectionId) {
    fetch(`${recommendedURL}&product_id=${productId}&section_id=${sectionId}`)
      .then((response) => response.text())
      .then((data) => {
        const html = document.createElement("div");
        html.innerHTML = data;
        const recommendedProducts = html.querySelector("related-products");

        if (recommendedProducts?.innerHTML.trim().length) {
          this.innerHTML = recommendedProducts.innerHTML;

          this.productsInner =
            this.querySelector(".related_products_inner") ||
            this.querySelector(".complementary_products_inner");

          this.initRecommendedSlider(
            this.productsInner,
            this.spacing,
            this.columns,
            this.mobColumns
          );

          document.dispatchEvent(new CustomEvent("related-products-updated"));                
        }
      });
  }

  getSwiperBreakpoints(spacing, columns, mobColumns) {
  if (this.type === 'complementary') {
    return {
      0: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      499: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },
      768: {
        slidesPerView: 1,
        spaceBetween: 15,
      },
      1024: {
        slidesPerView: 1.2,
        spaceBetween: 15,
      },
      1399: {
        slidesPerView: 1.5,
        spaceBetween: 15,
      },
    };
  }

  // DEFAULT → RELATED PRODUCTS
  return {
    0: {
      slidesPerView: mobColumns,
      spaceBetween: 15,
    },
    640: {
      slidesPerView: 2,
      spaceBetween: spacing,
    },
    768: {
      slidesPerView: 3,
      spaceBetween: spacing,
    },
    1280: {
      slidesPerView: 4,
      spaceBetween: spacing,
    },
    1399: {
      slidesPerView: columns,
      spaceBetween: spacing,
    },
  };
}


  initRecommendedSlider(inner, spacing, columns, mobColumns) {
    const prevBtn = this.querySelector('.swiper-button-prev');
    const nextBtn = this.querySelector('.swiper-button-next');

    new Swiper(inner, {
      slidesPerView: columns,
      spaceBetween: spacing,   
      speed: 600, 
      grabCursor: this.type === 'complementary',
      navigation: {
          nextEl: nextBtn,
          prevEl: prevBtn,
        },  
      pagination: {
        el: this.querySelector('.swiper-pagination'),
        clickable: true
      },
      breakpoints: this.getSwiperBreakpoints(
      spacing,
      columns,
      mobColumns
    ),
    });
  }
}

customElements.define("related-products", RelatedProducts);


// CART QUANTITY PICKER
class ItemQuantity extends HTMLElement {
  constructor() {
    super();
    this.minusBtn = this.querySelector('[data-minus]');
    this.input = this.querySelector('input[type="text"]');
    this.plusBtn = this.querySelector('[data-plus]');
    this.value = Number(this.input.value); 
    this.step = Number(this.input.getAttribute('step'));
    this.min = this.input.dataset.min;
    this.max = this.input.dataset.max;
    this.line = this.dataset.line;
  }

  connectedCallback() {
    this.minusBtn.addEventListener('click', this.handleChange.bind(this));
    this.plusBtn.addEventListener('click', this.handleChange.bind(this));
    const debouncedInputandler = this._debounce((e) => this.handleInput(e), 1000)
    this.input.addEventListener('input', debouncedInputandler);
  }

  handleChange(e) {
    if(e.currentTarget.hasAttribute('data-plus')) {
      this.value = this.value + this.step;
      this.input.value = this.value;
    } else {
      this.value = this.value - this.step;
      this.input.value = this.value;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }
    
    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    document.dispatchEvent(
      new CustomEvent('cart-quantity-change', {
        detail: {
          value: this.value,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    )    
  }

  handleInput(e) {
    this.value = Number(this.input.value);
    if(this.value == 0) {
      this.value = 1;
      this.input.value = 1;
    }

    if(this.min) {
      if(this.value <= this.min) {
        this.minusBtn.setAttribute('disabled', '');
      } else {
        this.minusBtn.removeAttribute('disabled');
      }
    }

    if(this.max) {
      if(this.value >= this.max) {
        this.plusBtn.setAttribute('disabled', '');
      } else {
        this.plusBtn.removeAttribute('disabled');
      }
    }

    this.dispatchEvent(
      new CustomEvent('cart-quantity-change', {
        detail: {
          value: this.value,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    ) 

  }

  _debounce(fn, wait = 1000) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }
}

customElements.define('item-quantity', ItemQuantity);

// CART REMOVE
class ItemRemove extends HTMLElement {
  constructor() {
    super();
    this.line = this.dataset.line;
    this.anchor = this.querySelector('a.item_remove_btn');
  }

  connectedCallback() {
    this.anchor.addEventListener('click', this.handleClick.bind(this));
  }

  handleClick(e) {
    e.preventDefault();

    document.dispatchEvent(
      new CustomEvent('cart-item-remove', {
        detail: {
          value: 0,
          line: this.line
        },
        bubbles: true,
        composed: true
      })
    )
  }
}

customElements.define('item-remove', ItemRemove);


// CART DISCOUNT
class CartDiscount extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[name="discount"]');
    this.value = this.input.value;    
    this.btn = this.querySelector('button[name="cart_discount_btn"]');    
    this.remove = this.querySelector('[data-cart-discount-remove]');
    this.error = this.querySelector('.cart_discount_error');
  }

  connectedCallback() {
    this.input.addEventListener('input', this.handleInput.bind(this));
    this.btn.addEventListener('click', this.handleClick.bind(this));
    if(!this.remove) return;
    this.remove.addEventListener('click', this.handleRemove.bind(this));
  }

  handleInput() {
    if(this.error) {
      this.error.classList.add('hidden');
    }
    this.value = this.input.value.trim();
  }

  handleClick(e) {
    e.preventDefault();

    if(!this.value) {
      if(this.error) {
        this.error.classList.remove('hidden');
        this.input.focus();
        return;
      }
    }

    document.dispatchEvent(
      new CustomEvent('discount-btn-click', {
        detail: {
          discount: this.value,          
        },
        bubbles: true, 
        composed: true
      })
    )
  }

  handleRemove(e) {
    e.preventDefault();

    document.dispatchEvent(
      new CustomEvent('discount-remove-click', {
        detail: {
          discount: ''
        },
        bubbles: true,
        composed: true
      })
    )
  }
}

customElements.define('cart-discount', CartDiscount);

// CART DRAWER & CART PAGE
class CartContents extends HTMLElement {
  constructor() {
    super();
    this.onQtyChange = this.onQtyChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleDiscountRemove = this.handleDiscountRemove.bind(this);
    this.inner = this.querySelector('.cart_drawer_inner') || this.querySelector('.main_cart_content');    
  }

  connectedCallback() {    
    document.addEventListener('cart-quantity-change', this.onQtyChange);
    document.addEventListener('cart-item-remove', this.handleRemove);
    document.addEventListener('discount-btn-click', this.handleClick);
    document.addEventListener('discount-remove-click', this.handleDiscountRemove);
    document.addEventListener('cart-update', updateCart); 
  }

  disconnectedCallback() {
    document.removeEventListener('cart-quantity-change', this.onQtyChange);
    document.removeEventListener('cart-item-remove', this.handleRemove);
    document.removeEventListener('discount-btn-click', this.handleClick);
    document.removeEventListener('discount-remove-click', this.handleDiscountRemove);
  }

  onQtyChange(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const { value, line } = e.detail;    

    const formData = {
      'line': line,
      'quantity': value,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then(async (res) => {
      const data = await res.json();

      if(!res.ok) {
        const sections = await fetch(`${window.Shopify.routes.root}?sections=cart-drawer,cart,cart-bubble`).then((res) => res.json());
        const rawData = {
          'line': line,
          'message': data.message || data.description,
          'sections': sections
        }

        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: rawData,
            bubbles: true
          })
        )       

        throw new Error(data.description || data.message || 'Request failed');
      }
      return data;
    })
    .then((rawData) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: rawData,
          bubbles: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      this.inner.classList.remove('loading')
    })
  }

  handleRemove(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const { value, line } = e.detail;

    const formData = {
      'line': line,
      'quantity': value,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail: data,
          bubbles: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      this.inner.classList.remove('loading');
    })
  } 

  handleClick(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const discount = e.detail.discount;

    const formData = {
      'discount': discount,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      if(data.discount_codes[0].applicable == false) {
        const error = this.querySelector('.cart_discount_error');
        
        if(error) {
          error.classList.remove('hidden');
          this.input.value = "";
        }

        if(this.inner) {
          this.inner.classList.remove('loading');
        }
      } else {
        document.dispatchEvent(
          new CustomEvent('cart-update', {
            detail: data,
            bubbles: true
          })
        )
      }      
    })
    .catch((err) => {
      console.error('Error: ', err)
    })
    .finally(() => {
      this.inner.classList.remove('loading');
    })
  }

  handleDiscountRemove(e) {
    if(this.inner) {
      this.inner.classList.add('loading');
    }

    const discount = e.detail.discount;

    const formData = {
      'discount': discount,
      'sections': 'cart-drawer,cart,cart-bubble'
    }

    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'        
      },
      body: JSON.stringify(formData)
    })
    .then((res) => res.json())
    .then((data) => {
      document.dispatchEvent(
        new CustomEvent('cart-update', {
          detail:data,
          bubble: true
        })
      )
    })
    .catch((err) => {
      console.error('Error: ', err);
    })
    .finally(() => {
      if(this.inner) {
        this.inner.classList.remove('loading');
      }
    })
  }
}

customElements.define('cart-contents', CartContents);

function updateCart(e) {
    const data = e.detail;
    const updatedDrawer = data.sections['cart-drawer'];
    const updatedCartPage = data.sections['cart'];
    const updatedCartBubble = data.sections['cart-bubble'];
    const div = document.createElement('div');
    const pageDiv = document.createElement('div');
    const bubbleDiv = document.createElement('div');
    const errorMsg = e.detail.message;
    const line = e.detail.line;

    // CART DRAWER UPDATE
    if(updatedDrawer) {
      div.innerHTML = updatedDrawer;
    }

    const oldDrawer = document.querySelector('cart-contents');

    if(oldDrawer) {
      const drawerHeader = oldDrawer.querySelector('.cart_drawer_header h4');
      const drawerContent = oldDrawer.querySelector('.cart_drawer_content_wrapper');
      const drawerFooter = oldDrawer.querySelector('.cart_drawer_items_footer');

      if(drawerHeader) {
        drawerHeader.innerHTML = div.querySelector('.cart_drawer_header h4').innerHTML;
      }

      if(drawerContent) {        
        drawerContent.innerHTML = div.querySelector('.cart_drawer_content_wrapper').innerHTML;
        if(errorMsg && line) {
          const errorWrapper = drawerContent.querySelector(`.cart_error[data-line="${line}"]`);

          if(errorWrapper) {
            errorWrapper.innerHTML = `<p>${errorMsg}</p>`
            errorWrapper.removeAttribute('hidden')
          }
        }
      }

      if(drawerFooter) {
        const updatedDrawerFooter = div.querySelector('.cart_drawer_items_footer');
        if(updatedDrawerFooter) {
          drawerFooter.innerHTML = div.querySelector('.cart_drawer_items_footer').innerHTML;
        }
      }
    }

    // MAIN CART PAGE UPDATE
    if(updatedCartPage) {
      pageDiv.innerHTML = updatedCartPage;
    }

    const oldCartPage = document.querySelector('cart-contents');

    if(oldCartPage) {
      const pageHeader = oldCartPage.querySelector('.main_cart_header');
      const pageContent = oldCartPage.querySelector('.main_cart_content');

      if(pageHeader) {
        pageHeader.innerHTML = pageDiv.querySelector('.main_cart_header').innerHTML;
      }

      if(pageContent) {
        pageContent.innerHTML = pageDiv.querySelector('.main_cart_content').innerHTML;

        if(errorMsg && line) {
          const errorWrapper = pageContent.querySelector(`.cart_error[data-line="${line}"]`);

          if(errorWrapper) {
            errorWrapper.innerHTML = `<p>${errorMsg}</p>`
            errorWrapper.removeAttribute('hidden')
          }
        }
      }
    }

    // CART BUBBLE UPDATE
    if(updatedCartBubble) {
      bubbleDiv.innerHTML = updatedCartBubble;
    }

    const oldBubble = document.querySelector('.cart-count-text');
    if(oldBubble) {
      oldBubble.innerHTML = bubbleDiv.querySelector('.cart-count-text').innerHTML;
    }
    
  }


  // CUSTOMER LOGIN
class CustomerLogin extends HTMLElement {
  constructor() {
    super();

    this.loginForm = this.querySelector('.main_customer_login_form_wrapper');
    this.recoverForm = this.querySelector('.main_customer_recover_form_wrapper');
    this.forgotPassword = this.querySelector('#forgot_password');
    this.cancel = this.querySelector('#recover_cancel_link');
    this.showContent();
  }

  connectedCallback() {
    this.forgotPassword.addEventListener('click', this.handleForgotPassword.bind(this));
    this.cancel.addEventListener('click', this.handleCancel.bind(this));
  }

  showContent() {
    const url = window.location.href;
    if(url.includes('#recover')) {
      this.loginForm.classList.add('hidden');
      this.recoverForm.classList.remove('hidden');
    } else {
      this.loginForm.classList.remove('hidden');
      this.recoverForm.classList.add('hidden');
    }
  }

  handleForgotPassword(e) {
    e.preventDefault();
    this.loginForm.classList.add('hidden');
    this.recoverForm.classList.remove('hidden');
    const url = `${window.location.href}#recover`
    window.history.replaceState({}, "", url);
  }

  handleCancel(e) {
    e.preventDefault();
    this.loginForm.classList.remove('hidden');
    this.recoverForm.classList.add('hidden');
    let url = window.location.href;
    url = url.split('#recover');
    window.history.replaceState({}, "", url[0]);
  }
}

customElements.define('customer-login', CustomerLogin)


Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

// QUICK ADD BUTTON
class QuickAdd extends HTMLElement {
  constructor() {
    super();
    this.productUrl = this.dataset.productUrl;
    this.btn = this.querySelector('button');
    this.drawerWrapper = document.querySelector('.quick_add_drawer')
    this.drawer = document.querySelector('.quick_add_drawer_inner');
    this.handleProductFetch = this.handleProductFetch.bind(this);
  }

  connectedCallback() {
    this.attachEventHandler();   
    
  }

  attachEventHandler() {
    if(this._isEventAttached) return;
    if(!this.btn) return;

    this._isEventAttached = true;
    this.btn.addEventListener('click', this.handleProductFetch)
  }

  showSkeleton() {
  this.drawer.innerHTML = `
    <div class="quick_add_skeleton">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 300 150"><path fill="none" stroke="#FF156D" stroke-width="15" stroke-linecap="round" stroke-dasharray="300 385" stroke-dashoffset="0" d="M275 75c0 31-27 50-50 50-58 0-92-100-150-100-28 0-50 22-50 50s23 50 50 50c58 0 92-100 150-100 24 0 50 19 50 50Z"><animate attributeName="stroke-dashoffset" calcMode="spline" dur="2" values="685;-685" keySplines="0 0 1 1" repeatCount="indefinite"></animate></path></svg>
    </div>
  `;
}

  handleProductFetch() {
  this.showSkeleton();

  fetch(`${this.productUrl}`)
    .then((res) => res.text())
    .then((htmlString) => {
      const div = document.createElement('div');
      div.innerHTML = htmlString;

      const newHTML = div.querySelector('.main_product_section_inner');
      if (!newHTML) return;

      const mainProduct = newHTML.querySelector('main-product');

      const originalSectionId = mainProduct.dataset.sectionId;
      const quickAddSectionId = `quick-add-${originalSectionId}`;

      // Replace IDs
      newHTML.innerHTML = newHTML.innerHTML.replaceAll(
        originalSectionId,
        quickAddSectionId
      );

      newHTML.querySelector('main-product').dataset.originalSectionId = originalSectionId;
      newHTML.querySelector('main-product').dataset.updateUrl = 'false';    
      
      const tabs = newHTML.querySelectorAll('.main_product_collapsible_wrapper');
      if(tabs) {
        tabs.forEach((tab) => {
          tab.remove();
        })
      }

      const pickup = newHTML.querySelector('.main_product_pickup_availability_wrapper');
      if(pickup) {
        pickup.remove();
      }

      // Inject
      this.drawer.replaceChildren(...newHTML.children);
    });

    openDrawer(this.drawerWrapper, this.btn)
}

}

customElements.define('quick-add', QuickAdd);

document.addEventListener('collection-grid-update', () => {
  console.log('grid updated')
  document.querySelectorAll('quick-add').forEach((el) => {
    el.attachEventHandler();
  });
});

document.addEventListener('related-products-update', () => {
  document.querySelectorAll('quick-add').forEach((el) => {
    el.attachEventHandler();
  });
  
});


// GIFT CARD RECIPIENT FORM
if (!customElements.get('recipient-form')) {
  customElements.define(
    'recipient-form',
    class RecipientForm extends HTMLElement {
      constructor() {
        super();
        this.checkbox = this.querySelector(`#Recipient_checkbox--${this.dataset.sectionId}`);
        this.checkbox.disabled = false;
        this.hiddenControls = this.querySelector(`#Recipient_control--${this.dataset.sectionId}`);
        this.wrapper = this.querySelector('.recipients_input_wrapper');
        this.inner = this.wrapper.querySelector('.recipients_input_inner');
        this.hiddenControls.disabled = true;

        this.emailInput = this.querySelector(`#Recipient_email--${this.dataset.sectionId}`);
        this.nameInput = this.querySelector(`#Recipient_name--${this.dataset.sectionId}`);
        this.messageInput = this.querySelector(`#Recipient_message--${this.dataset.sectionId}`);
        this.sendonInput = this.querySelector(`#Recipient_send_on--${this.dataset.sectionId}`);
        this.offsetProperty = this.querySelector(`#Recipient_timezone_offset--${this.dataset.sectionId}`);
        if (this.offsetProperty) this.offsetProperty.value = new Date().getTimezoneOffset().toString();

        this.currentProductVariantId = this.dataset.variantId;
        this.addEventListener('change', this.onChange.bind(this));
      }

      connectedCallback() {
        const height = this.inner.clientHeight;
        this.wrapper.style.setProperty('--height', `${height}px`);
      }

      onChange() {
        if(this.checkbox.checked) {
          this.wrapper.setAttribute('open', '');
        } else {
          this.wrapper.removeAttribute('open');
        }
      }
    }
  )
}

// VIDEO SECTION
class VideoSection extends HTMLElement {
  constructor() {
    super();
    this.playBtn = this.querySelector('.video_play_btn');
    this.imgWrapper = this.querySelector('.video_section_poster_img_wrapper');
    this.vdoWrapper = this.querySelector('.video_section_video_wrapper');
    this.video = this.querySelector('video');
    this.iframe = this.querySelector('iframe');
  }

  connectedCallback() {
    this.playBtn.addEventListener('click', this.handleClick.bind(this));
    if(this.video) {
      this.video.addEventListener('click', this.handleVdoClick.bind(this));
    }
  }

  handleClick() {
    if(!this.imgWrapper && !this.vdoWrapper) return;
    this.imgWrapper.classList.add('hide');

    if(this.video) {
      this.video.setAttribute('tabIndex', '0');
      this.video.play();
    } else {
      this.iframe.setAttribute('tabIndex', '0');
      const source = this.iframe.getAttribute("src");
        if (source.includes("youtube.com") || source.includes("youtu.be")) {
          this.iframe.contentWindow.postMessage(
            '{"event":"command","func":"playVideo","args":""}',
            "*"
          );
        } else if (source.includes("vimeo.com")) {
          this.iframe.contentWindow.postMessage(
            '{"method":"play"}',
            "https://player.vimeo.com"
          );
        }
    }
  }

  handleVdoClick() {
    if(this.vdoWrapper.classList.contains('controls_enabled')) {} else {
      if(this.video.paused) {
        this.video.play();
      } else {
        this.video.pause();
      }
    }
  }
}

 customElements.define('video-section', VideoSection);

 class ProductCard extends HTMLElement { 
  constructor() {
    super();
    this.link = this.querySelector('.product_card_link');
    this.quickView = this.querySelector('.quick_view_wrapper');
  }

  connectedCallback() {
    if(this.link && this.quickView) {
      this.link.addEventListener('focus', (e) => {
        if(e.target.matches(':focus-visible')) {
          this.quickView.style.transform = 'translateX(0)';
        }
      })
    }
  }
 }
 customElements.define('product-card', ProductCard);


 //  PRODUCT MEDIA
class ProductMedia extends HTMLElement {
  constructor() {
    super();
    this.videos = this.querySelectorAll('video');
    this.yFrames = this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
    this.vFrames = this.querySelectorAll('iframe[src*="vimeo.com"]');
    this.models = this.querySelectorAll('product-model');
  }

  connectedCallback() {
    if(this.videos.length) {
      this.videos.forEach((video) => {
        video.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleVdoClick(video);
        })
      })
    }

    if(this.yFrames.length) {
      this.yFrames.forEach((yFrame) => {
        yFrame.nextElementSibling.addEventListener('click', () => {
          yFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleYframeClick(yFrame);
        })
      })
    }

    if(this.vFrames.length) {
      this.vFrames.forEach((vFrame) => {
        vFrame.nextElementSibling.addEventListener('click', () => {
          vFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleVframeClick(vFrame);
        })
      })
    }

    if(this.models.length) {
      this.models.forEach((model) => {
        model.addEventListener('mouseenter', () => {
          lenis.stop();
          document.documentElement.style.overflow = 'auto';
        })

        model.addEventListener('mouseleave', () => {
          lenis.start();
          document.documentElement.style.overflow = 'unset';
        })

        model.addEventListener('click', () => this.handleModelClick(model));
      })
    }
  }

  handleVdoClick(vdo) {
    this.pauseAllMedia(vdo);
    vdo.nextElementSibling.classList.add('hide');
    if(vdo.paused) {
      vdo.play();
      vdo.nextElementSibling.classList.add('hide'); 
    } else {
      vdo.pause();
      vdo.nextElementSibling.classList.remove('hide');
    }
  }

  handleYframeClick(yFrame) {
    this.pauseAllMedia(yFrame);
    yFrame.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: "playVideo", args: [] }),
      "*"
    );
  }

  handleVframeClick(vFrame) {
    this.pauseAllMedia(vFrame);
    vFrame.contentWindow.postMessage(
      { method: "play" },
      "*"
    );
  }

  handleModelClick(model) {
    console.log('click')
    this.pauseAllMedia(model)
  }

  pauseAllMedia(except = null) {
    this.videos.forEach((vdo) => {
      if(vdo != except) {
        vdo.nextElementSibling.classList.remove('hide');
        vdo.pause();
      }
    })

    this.yFrames.forEach((yFrame) => {
      if (yFrame !== except) {
        yFrame.nextElementSibling.style.pointerEvents = 'all';
        yFrame.contentWindow.postMessage(
          JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
          "*"
        );
      }
    });

    this.vFrames.forEach((vFrame) => {
      if (vFrame !== except) {
        vFrame.nextElementSibling.style.pointerEvents = 'all';
        vFrame.contentWindow.postMessage({ method: "pause" }, "*");
      }
    });

    this.models.forEach((model) => {
      if(model !== except) {
        const modelViewer = model.querySelector('model-viewer');

        if(!modelViewer) return;
        if (model.modelViewerUI) model.modelViewerUI.pause();
      }
    })
  }
}
customElements.define('product-media', ProductMedia);


// PRODUCT MOBILE MEDIA
class ProductMobileMedia extends HTMLElement {
  constructor() {
    super();
    this.mainSlider = this.querySelector('.product_mobile_main_media');
    this.thumbSlider = this.querySelector('.product_mobile_thumbnail_media');
    this.spacing = this.dataset.spacing;
    this.videos = this.querySelectorAll('video');
    this.yFrames = this.querySelectorAll('iframe[src*="youtube.com"], iframe[src*="youtu.be"]');
    this.vFrames = this.querySelectorAll('iframe[src*="vimeo.com"]');
    this.models = this.querySelectorAll('product-model'); 
  }

  connectedCallback() {
    if(!this.mainSlider) return;

    if(this.mainSwiper) this.mainSwiper.destroy(true, true);
    if(this.thumbSwiper) this.thumbSwiper.destroy(true, true);
   

    if(this.videos.length) {
      this.videos.forEach((video) => {
        video.addEventListener('click', (e) => {
          e.preventDefault();
          this.handleVdoClick(video);
        })

        video.addEventListener('touchend', (e) => {
          e.preventDefault();
          this.handleVdoClick(video);
        })
      })
    }

    if(this.yFrames.length) {
      this.yFrames.forEach((yFrame) => {
        yFrame.nextElementSibling.addEventListener('click', () => {
          yFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleYframeClick(yFrame);
        })

        yFrame.nextElementSibling.addEventListener('touchend', () => {
          yFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleYframeClick(yFrame);
        })
      })
    }

    if(this.vFrames.length) {
      this.vFrames.forEach((vFrame) => {
        vFrame.nextElementSibling.addEventListener('click', () => {
          vFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleVframeClick(vFrame);
        })

        vFrame.nextElementSibling.addEventListener('touchend', () => {
          vFrame.nextElementSibling.style.pointerEvents = 'none';
          this.handleVframeClick(vFrame);
        })
      })
    }

    if(this.models.length) {
      this.models.forEach((model) => {
        model.addEventListener('mouseenter', () => {  
          lenis.stop();     
          document.documentElement.style.overflow = 'auto';
          if (this.mainSwiper) this.mainSwiper.allowTouchMove = false;
        })

        model.addEventListener('mouseleave', () => {        
          lenis.start();
          document.documentElement.style.overflow = 'unset';
          if (this.mainSwiper) this.mainSwiper.allowTouchMove = true;
        })  

        model.addEventListener('touchstart', () => {  
          lenis.stop();     
          document.documentElement.style.overflow = 'auto';
          if (this.mainSwiper) this.mainSwiper.allowTouchMove = false;
        })

        model.addEventListener('touchend', () => {        
          lenis.start();
          document.documentElement.style.overflow = 'unset';
          if (this.mainSwiper) this.mainSwiper.allowTouchMove = true;
        })   
        //model.addEventListener('click', (e) => this.handleModelClick(model));      
        model.addEventListener('touchend', (e) => this.handleModelClick(model));    
      });
    }  

    
  }

   handleVdoClick(vdo) {
    this.pauseAllMedia(vdo);
    vdo.nextElementSibling.classList.add('hide');
    if(vdo.paused) {
      vdo.play();
      vdo.nextElementSibling.classList.add('hide'); 
    } else {
      vdo.pause();
      vdo.nextElementSibling.classList.remove('hide');
    }
  }

  handleYframeClick(yFrame) {
    this.pauseAllMedia(yFrame);
    yFrame.contentWindow.postMessage(
      JSON.stringify({ event: "command", func: "playVideo", args: [] }),
      "*"
    );
  }

  handleVframeClick(vFrame) {
    this.pauseAllMedia(vFrame);
    vFrame.contentWindow.postMessage(
      { method: "play" },
      "*"
    );
  }

  handleModelClick(model) {
    if (this.mainSwiper) this.mainSwiper.allowTouchMove = false;
    this.pauseAllMedia(model);
  }

  pauseAllMedia(except = null) {
    this.videos.forEach((vdo) => {
      if(vdo != except) {
        vdo.nextElementSibling.classList.remove('hide');
        vdo.pause();
      }
    })

    this.yFrames.forEach((yFrame) => {
      if (yFrame !== except) {
        yFrame.nextElementSibling.style.pointerEvents = 'all';
        yFrame.contentWindow.postMessage(
          JSON.stringify({ event: "command", func: "pauseVideo", args: [] }),
          "*"
        );
      }
    });

    this.vFrames.forEach((vFrame) => {
      if (vFrame !== except) {
        vFrame.nextElementSibling.style.pointerEvents = 'all';
        vFrame.contentWindow.postMessage({ method: "pause" }, "*");
      }
    });

    this.models.forEach((model) => {
      if(model !== except) {
        const modelViewer = model.querySelector('model-viewer');

        if(!modelViewer) return;
        if (model.modelViewerUI) model.modelViewerUI.pause();

        model.querySelector('.shopify-model-viewer-ui__button').removeAttribute('hidden')
      }
    })
  }
}

customElements.define('product-mobile-media', ProductMobileMedia);

// MAGNETIC BUTTON
class MagneticButton extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('button, a');
    this.radius = Number(this.dataset.radius) || 120;

    this.mediaQuery = window.matchMedia('(min-width: 641px)');
    this.enabled = false;

    this.onMouseMove = this.onMouseMove.bind(this);
    this.onMouseLeave = this.onMouseLeave.bind(this);
    this.onMediaChange = this.onMediaChange.bind(this);
  }

  connectedCallback() {
    if (!this.button) return;

    // Initial check
    this.toggleEffect(this.mediaQuery.matches);

    // Listen for screen size changes (resize + devtools)
    this.mediaQuery.addEventListener('change', this.onMediaChange);
  }

  disconnectedCallback() {
    this.disableEffect();
    this.mediaQuery.removeEventListener('change', this.onMediaChange);
  }

  onMediaChange(e) {
    this.toggleEffect(e.matches);
  }

  toggleEffect(shouldEnable) {
    if (shouldEnable && !this.enabled) {
      window.addEventListener('mousemove', this.onMouseMove);
      window.addEventListener('mouseleave', this.onMouseLeave);
      this.enabled = true;
    }

    if (!shouldEnable && this.enabled) {
      this.disableEffect();
    }
  }

  disableEffect() {
    window.removeEventListener('mousemove', this.onMouseMove);
    window.removeEventListener('mouseleave', this.onMouseLeave);
    this.button.style.transform = 'translate(0, 0)';
    this.enabled = false;
  }

  onMouseMove(e) {
    if (!this.enabled) return;

    const rect = this.button.getBoundingClientRect();
    const btnX = rect.left + rect.width / 2;
    const btnY = rect.top + rect.height / 2;

    const distX = e.clientX - btnX;
    const distY = e.clientY - btnY;
    const distance = Math.hypot(distX, distY);

    if (distance < this.radius) {
      const force = (this.radius - distance) / this.radius;
      this.button.style.transform = `translate(${distX * force * 0.3}px, ${distY * force * 0.3}px)`;
    } else {
      this.button.style.transform = 'translate(0, 0)';
    }
  }

  onMouseLeave() {
    this.button.style.transform = 'translate(0, 0)';
  }
}

customElements.define('magnetic-button', MagneticButton);

// CART NOTE
class CartNote extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.textarea = this.querySelector('textarea');
    this.debounceTimer = null;
  }

  connectedCallback() {
    if (this.textarea && this.textarea.value.trim() !== '') {
      this.details.setAttribute('open', '');
    }

    this.textarea.addEventListener('input', () => {
      this.details.setAttribute('open', '');

      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        this.updateCartNote(this.textarea.value.trim());
      }, 500); 
    });
  }

  updateCartNote(value) {
    fetch(`${window.Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        note: value
      })
    })
    .then(res => res.json())
    .then(() => {
      console.log('Cart note updated');
    })
    .catch(err => {
      console.error('Cart note update failed', err);
    });
  }
}

customElements.define('cart-note', CartNote);

// SCROLL TO TOP
class ScrollToTop extends HTMLElement {
  constructor() {
    super();    
  }

  connectedCallback() {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 150) {
        this.classList.add("show");
      } else {
        this.classList.remove("show");
      }
    })

    this.addEventListener("click", () => {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    });
  }
}

customElements.define('scroll-to-top', ScrollToTop);


  // BMI calculator
class BMICalculator extends HTMLElement {
  connectedCallback() {
    /* -------------------------------
       ELEMENT REFERENCES
    -------------------------------- */
    this.tabs = this.querySelectorAll('.tab');
    this.contents = this.querySelectorAll('.tab-content');

    this.bmiBtn = this.querySelector('[data-action="bmi"]');

    this.bmiResult = this.querySelector('[data-bmi-result]');

    this.weightInput = this.querySelector('#bmi_weight');
    this.heightInput = this.querySelector('#bmi_height');

    this.weightToggle = this.querySelector('#weightToggle');
    this.heightToggle = this.querySelector('#heightToggle');

    this.metricLabels = this.querySelectorAll('.unit-label.metric');
    this.imperialLabels = this.querySelectorAll('.unit-label.imperial');

    /* -------------------------------
       STATE
    -------------------------------- */
    this.isImperial = false;

    /* -------------------------------
       EVENTS
    -------------------------------- */
    this.tabs.forEach(tab =>
      tab.addEventListener('click', () => this.switchTab(tab))
    );

    this.bmiBtn?.addEventListener('click', () => this.calculateBMI());

    this.weightToggle?.addEventListener('change', () => {
      this.syncUnits(this.weightToggle.checked);
    });

    this.heightToggle?.addEventListener('change', () => {
      this.syncUnits(this.heightToggle.checked);
    });

    /* -------------------------------
       INIT
    -------------------------------- */
    this.syncUnits(false);
  }

  /* -------------------------------
     TAB SWITCH
  -------------------------------- */
  switchTab(tab) {
    const target = tab.dataset.tab;

    this.tabs.forEach(t => t.classList.remove('active'));
    this.contents.forEach(c => c.classList.remove('active'));

    tab.classList.add('active');
    this.querySelector(`#${target}`)?.classList.add('active');
  }

  /* -------------------------------
     UNIT SYNC (CORE LOGIC)
  -------------------------------- */
  syncUnits(isImperial) {
    this.isImperial = isImperial;

    // Sync both toggles
    if (this.weightToggle) this.weightToggle.checked = isImperial;
    if (this.heightToggle) this.heightToggle.checked = isImperial;

    // Update placeholders
    if (isImperial) {
      this.weightInput.placeholder = 'Weight (lb)';
      this.heightInput.placeholder = 'Height (ft)';
    } else {
      this.weightInput.placeholder = 'Weight (kg)';
      this.heightInput.placeholder = 'Height (cm)';
    }

    // Update labels
    this.metricLabels.forEach(l => l.classList.toggle('active', !isImperial));
    this.imperialLabels.forEach(l => l.classList.toggle('active', isImperial));
  }

  /* -------------------------------
     ERROR HANDLING
  -------------------------------- */
  showError(tabId, message) {
    const tab = this.querySelector(`#${tabId}`);
    const error = tab?.querySelector('.error_message');

    if (!error) return;

    error.textContent = message;
    error.hidden = false;
  }

  hideError(tabId) {
    const tab = this.querySelector(`#${tabId}`);
    const error = tab?.querySelector('.error_message');

    if (!error) return;
    error.hidden = true;
  }

  /* -------------------------------
     BMI CALCULATION
     Always uses kg / meters internally
  -------------------------------- */
  calculateBMI() {
    let weight = parseFloat(this.weightInput.value);
    let height = parseFloat(this.heightInput.value);

    if (!weight || !height) {
      this.showError('bmi', 'Please enter weight and height.');
      return;
    }

    this.hideError('bmi');

    // Convert to metric if imperial
    if (this.isImperial) {
      weight = weight * 0.453592; // lb → kg
      height = height * 30.48;    // ft → cm
    }

    const heightMeters = height / 100;
    const bmi = (weight / (heightMeters ** 2)).toFixed(1);

    const category =
      bmi < 18.5 ? 'Underweight' :
      bmi < 25 ? 'Normal' :
      bmi < 30 ? 'Overweight' :
      'Obese';

    this.bmiResult.innerHTML =
      `Your BMI is <strong>${bmi}</strong> (${category})`;
  }
}

customElements.define('bmi-calculator', BMICalculator);

// Collection tab
class CollectionTabs extends HTMLElement {
  constructor() {
    super();
    this.swipers = new Map();
  }

  connectedCallback() {
    this.tabButtons = [...this.querySelectorAll('.collection-tabs-tab-btn')];
    this.tabPanels = [...this.querySelectorAll('.collection-tabs-tab-panel')];

    this.activate(0);

    this.tabButtons.forEach((btn, i) => {
      btn.addEventListener("click", () => this.activate(i));
    });
  }

  /* -----------------------------
    TAB SWITCHING
  ------------------------------ */
  activate(index) {
    this.tabButtons.forEach((btn, i) => {
      btn.classList.toggle("active", i === index);
    });

    this.tabPanels.forEach((panel, i) => {
      const isActive = i === index;

      if (isActive) {
        panel.hidden = false;
        panel.offsetHeight; // force reflow
        panel.classList.add("active");

        //this.initSwiper(panel);
      } else {
        panel.classList.remove("active");
        //this.destroySwiper(panel);
        panel.hidden = true;
      }

      this.updateFocus(panel, isActive);
    });
  }

  /* -----------------------------
    READ CSS VARIABLE
  ------------------------------ */
  getDesktopColumns() {
    const section = this.querySelector('.collection-tabs-tabs-section');
    if (!section) return 4;

    const value = getComputedStyle(section)
      .getPropertyValue('--columns')
      .trim();

    return parseInt(value, 10) || 4;
  }

  /* -----------------------------
    INIT SWIPER
  ------------------------------ */
  // initSwiper(panel) {
  //   const swiperEl = panel.querySelector(".swiper");
  //   if (!swiperEl || this.swipers.has(panel)) return;

  //   const prevEl = panel.querySelector(".swiper-button-prev");
  //   const nextEl = panel.querySelector(".swiper-button-next");

  //   const desktopColumns = this.getDesktopColumns();

  //   const swiper = new Swiper(swiperEl, {
  //     slidesPerView: 1,
  //     spaceBetween: 20,
  //     loop: false,

  //     navigation: {
  //       prevEl,
  //       nextEl,
  //     },

  //     breakpoints: {
  //       0: { slidesPerView: 1 },
  //       350: { slidesPerView: 1 },
  //       768: { slidesPerView: 2 },
  //       1024: { slidesPerView: Math.min(3, desktopColumns) },
  //       1200: { slidesPerView: desktopColumns },
  //     },

  //     observer: true,
  //     observeParents: true,
  //   });

  //   this.swipers.set(panel, swiper);
  // }

  /* -----------------------------
    DESTROY SWIPER
  ------------------------------ */
  // destroySwiper(panel) {
  //   const swiper = this.swipers.get(panel);
  //   if (!swiper) return;

  //   swiper.destroy(true, true);
  //   this.swipers.delete(panel);
  // }

  /* -----------------------------
    ACCESSIBILITY
  ------------------------------ */
  updateFocus(panel, active) {
    const focusable = panel.querySelectorAll("a, button, input, [tabindex]");

    focusable.forEach(el => {
      if (!active) {
        el.tabIndex = -1;
        return;
      }

      if (el.closest(".product_title_p")) {
        el.tabIndex = -1;
        return;
      }

      const imageWrap = el.closest(".product_block_img_info");
      if (imageWrap) {
        const firstLink = imageWrap.querySelector("a");
        el.tabIndex = el === firstLink ? 0 : -1;
        return;
      }

      el.tabIndex = 0;
    });
  }
}

customElements.define("collection-tabs", CollectionTabs);



// Banner Tabs
class BannerTabs extends HTMLElement {
  constructor() {
    super();

  }

  connectedCallback() {
    this.tabButtons = [
      ...this.closest('.section_padding')
        .querySelectorAll('.banner-tabs-tab-btn')
    ];

    this.tabPanels = [
      ...this.querySelectorAll('.banner-tab-panel')
    ];

    if (!this.tabButtons.length || !this.tabPanels.length) return;

    this.activate(0);

    this.tabButtons.forEach((btn, i) => {
      btn.addEventListener('click', () => this.activate(i));
    });
  }

  /* -----------------------------
     TAB SWITCHING
  ------------------------------ */
activate(index) {
  this.tabButtons.forEach((btn, i) => {
    btn.classList.toggle('active', i === index);
  });

  this.tabPanels.forEach((panel, i) => {
    const isActive = i === index;

    if (isActive) {
      panel.hidden = false;
      panel.offsetHeight; // force reflow
      panel.classList.add('active');

      // update swiper when tab becomes visible
      const swiperSection = panel.querySelector('swiper-section');
      if (swiperSection?.swiper) {
        swiperSection.swiper.update();
      }
    } else {
      panel.classList.remove('active');
      panel.hidden = true;
    }

    this.updateFocus(panel, isActive);
  });
}

  /* -----------------------------
     READ CSS VARIABLE
  ------------------------------ */
  getDesktopColumns() {
    const section = this.querySelector('.banner-tabs-section');
    if (!section) return 4;

    const value = getComputedStyle(section)
      .getPropertyValue('--columns')
      .trim();

    return parseInt(value, 10) || 4;
  }

  /* -----------------------------
     ACCESSIBILITY
  ------------------------------ */
  updateFocus(panel, active) {
    const focusable = panel.querySelectorAll(
      'a, button, input, select, textarea, [tabindex]'
    );

    focusable.forEach(el => {
      if (!active) {
        el.tabIndex = -1;
        return;
      }

      if (el.closest('.product_title_p')) {
        el.tabIndex = -1;
        return;
      }

      const imageWrap = el.closest('.product_block_img_info');
      if (imageWrap) {
        const firstLink = imageWrap.querySelector('a');
        el.tabIndex = el === firstLink ? 0 : -1;
        return;
      }

      el.tabIndex = 0;
    });
  }
}
customElements.define('banner-tabs', BannerTabs);


// RECENTLY VIEWED
class RecentlyViewed extends HTMLElement {
  constructor() {
    super();

    this.storageKey = 'recently-viewed-products';
    this.sectionSelector = '[data-recently-viewed]';

    this.currentHandle = this.dataset.productHandle;
    this.maxProducts = Number(this.dataset.columns) || 4;
    this.aspectRatio = this.dataset.aspectRatio || 'square';
    this.moneyFormat = this.dataset.moneyFormat || '${{amount}}';
  }

  connectedCallback() {
    if (!this.currentHandle) return;

    this.updateRecentlyViewed();
    this.displayProducts();
  }

  /* --------------------------------------------
    UPDATE LOCAL STORAGE
  -------------------------------------------- */
  updateRecentlyViewed() {
    let viewed = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    viewed = viewed.filter(handle => handle !== this.currentHandle);
    viewed.unshift(this.currentHandle);

    if (viewed.length > this.maxProducts) {
      viewed = viewed.slice(0, this.maxProducts);
    }

    localStorage.setItem(this.storageKey, JSON.stringify(viewed));
  }

  /* --------------------------------------------
    LOAD & DISPLAY PRODUCTS
  -------------------------------------------- */
  async displayProducts() {
    const section = document.querySelector(this.sectionSelector);
    if (!section) return;

    const handles = JSON.parse(localStorage.getItem(this.storageKey)) || [];

    if (!handles.length) {
      section.style.display = 'none';
      return;
    }

    try {
      const products = await Promise.all(
        handles.map(handle =>
          fetch(`/products/${handle}.js`).then(res => res.json())
        )
      );

      section.innerHTML = `
        <div class="recently_viewed_inner">
          ${products.map(product => this.renderProduct(product)).join('')}
        </div>
      `;
    } catch (error) {
      console.error('Recently Viewed error:', error);
      section.style.display = 'none';
    }
  }

  /* --------------------------------------------
    RENDER PRODUCT CARD
  -------------------------------------------- */
  renderProduct(product) {
    if (!product) return '';

    const variant = product.variants[0];
    const price = variant.price;
    const compareAt = variant.compare_at_price;
    const hasSale = compareAt && compareAt > price;

    const image = product.images?.[0] || "";
    // const imageSrc = image?.src || '';

    let ratio = 100;
    if (this.aspectRatio === 'portrait') ratio = 140;
    if (this.aspectRatio === 'square') ratio = 100;
    if (this.aspectRatio === 'adapt' && image) {
      ratio = 100;
    }

    return `
      <div class="recent_products">
        <div class="recent_product_img ratio" style="--aspect-ratio:${ratio}%">
          <a href="/products/${product.handle}" aria-label="${product.title}">
            ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : ''}
          </a>
        </div>

        <div class="recent_product_info">
          <p class="small-text">
            <a href="/products/${product.handle}">${product.title}</a>
          </p>

          <div class="recent_product_price">
            <span class="${hasSale ? 'sale_p' : 'regular'}">
              ${Shopify.formatMoney(price, this.moneyFormat)}
            </span>
            ${hasSale ? `<s>${Shopify.formatMoney(compareAt, this.moneyFormat)}</s>` : ''}
          </div>
        </div>
      </div>
    `;
  }
}

customElements.define('recently-viewed', RecentlyViewed);


// VIDEO IMAGE ALT TEXT
document.addEventListener('DOMContentLoaded', () => {
  const vdos = document.querySelectorAll('video');
  if(vdos.length) {
    vdos.forEach((vdo) => {
      const img = vdo.querySelector('img');
      if(img) {
        img.setAttribute('alt', 'Video image');
      }
    })
  }
})  


/* ------------------------------------------
      Hotspot section
------------------------------------------- */

class HotspotComponent extends HTMLElement {
  constructor() {
    super();
    this._handleButtonClick = this._handleButtonClick.bind(this);
    this._handleOutsideClick = this._handleOutsideClick.bind(this);
  }

  connectedCallback() {
    this.buttons = this.querySelectorAll(".lg-hotspot__button");
    this.hotspots = this.querySelectorAll(".lg-hotspot");
    this.mobileLabels = this.querySelectorAll(
      ".htp-container-lable-mobile .lg-hotspot__label.mobile_hotspot_label"
    );

    this.buttons.forEach(button => {
      button.addEventListener("click", this._handleButtonClick);
    });

    document.addEventListener("click", this._handleOutsideClick);
  }

  disconnectedCallback() {
    this.buttons.forEach(button => {
      button.removeEventListener("click", this._handleButtonClick);
    });

    document.removeEventListener("click", this._handleOutsideClick);
  }

  _handleButtonClick(e) {
    e.stopPropagation(); // Prevent outside click logic

    const clickedHotspot = e.target.closest(".lg-hotspot");
    const index = clickedHotspot.dataset.index; // get data-index

    // For mobile: show the corresponding label in .htp-container-lable-mobile
    if (window.innerWidth <= 1023) { // adjust breakpoint if needed
      this.mobileLabels.forEach(label => {
        if (label.dataset.index === index) {
          label.style.display = "block";
          label.classList.add("show_product_htp"); 
        } else {
          label.style.display = "none";
          label.classList.remove("show_product_htp");
        }
      });
    } else {
      // For desktop, toggle label inside hotspot as before
      this.hotspots.forEach(hotspot => {
        if (hotspot === clickedHotspot) {
          hotspot.classList.toggle("lg-hotspot--selected");
        } else {
          hotspot.classList.remove("lg-hotspot--selected");
        }
      });
    }
  }

  _handleOutsideClick(e) {
    // Hide mobile labels if clicked outside
    if (window.innerWidth <= 1023) {
      this.mobileLabels.forEach(label => {
        if (!label.contains(e.target)) {
          label.style.display = "none";
        }
      });
    } else {
      this.hotspots.forEach(hotspot => {
        if (!hotspot.contains(e.target)) {
          hotspot.classList.remove("lg-hotspot--selected");
        }
      });
    }
  }
}

customElements.define("hotspot-image", HotspotComponent);


/* ------------------------------------------
      Announcement popup section
------------------------------------------- */

class AnnouncementPopup extends HTMLElement {
  static get observedAttributes() {
      return ['open'];
  }

    connectedCallback() {
      this.wrapper = this.querySelector('.announcement_popup_section');
      this.close = this.querySelector('.announcement_popup_close_button');

      if (this.hasAttribute('open')) {
        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.show();
          });
        });
      } else if (this.shouldAppearAutomatically) {
        setTimeout(() => this.show(), this.delay);
      }

      this.close?.addEventListener('click', (e) => {
        e.preventDefault();
        this.hide();

        const currentUrl = window.location.href;

        const newUrl = currentUrl
          .replace('?customer_posted=true', '')
          .replace('#announcement-announcement-popup', '')
          .replace(/(&|\?)$/, '');

        window.history.replaceState({}, document.title, newUrl);
      });
    }

    get delay() {
      return parseInt(this.getAttribute('delay') || '0', 10) * 1000;
    }

    show() {
      this.wrapper.classList.add('visible');
      this.setAttribute('open', 'true');
    }

    hide() {
      this.wrapper.classList.remove('visible');
      this.removeAttribute('open');
    }

    get shouldAppearAutomatically() {
      return !(
        localStorage.getItem('theme:popup-filled') === 'true' ||
        (this.hasAttribute('only-once') && localStorage.getItem('theme:popup-appeared') === 'true')
      );
    }

    attributeChangedCallback(name, oldValue, newValue) {
      if (name === 'open' && newValue === 'true') {
        localStorage.setItem('theme:popup-appeared', 'true');
      }
    }
  }

  if (!customElements.get('announcement-popup')) {
    customElements.define('announcement-popup', AnnouncementPopup);
  }


/* ------------------------------------------
      Promotional bar countdown section
------------------------------------------- */

class PromotionalCountdownTimer extends HTMLElement {
  constructor() {
    super();
    this.sectionId = this.dataset.sectionId;
    this.endDate = new Date(this.dataset.time).getTime();
    this.daysEl = this.querySelector(".countdown_days h2");
    this.hoursEl = this.querySelector(".countdown_hours h2");
    this.minutesEl = this.querySelector(".countdown_minutes h2");
    this.secondsEl = this.querySelector(".countdown_seconds h2");
    this.prev = { days: "", hours: "", minutes: "", seconds: "" };
    this.interval = null;
  }

  connectedCallback() {
    if (isNaN(this.endDate)) {
      this.showDefault();
      return;
    }
    this.startCountdown();
  }

  disconnectedCallback() {
    if (this.interval) clearInterval(this.interval);
  }

  startCountdown() {
    this.updateCountdown(); 
    this.interval = setInterval(() => {
      this.updateCountdown();
    }, 1000);
  }

  animateChange(el, value, prevValue) {
    if (value !== prevValue) {
      el.textContent = String(value).padStart(2, "0");
      el.classList.remove("animate");
      void el.offsetWidth;
      el.classList.add("animate");
    }
  }

  updateCountdown() {
    const now = new Date().getTime();
    const distance = this.endDate - now;

    if (distance <= 0) {
      clearInterval(this.interval);
      this.daysEl.textContent = "00";
      this.hoursEl.textContent = "00";
      this.minutesEl.textContent = "00";
      this.secondsEl.textContent = "00";
      return;
    }

    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);

    this.animateChange(this.daysEl, days, this.prev.days);
    this.animateChange(this.hoursEl, hours, this.prev.hours);
    this.animateChange(this.minutesEl, minutes, this.prev.minutes);
    this.animateChange(this.secondsEl, seconds, this.prev.seconds);

    this.prev = { days, hours, minutes, seconds };
  }

  showDefault() {
    this.daysEl.textContent = "00";
    this.hoursEl.textContent = "00";
    this.minutesEl.textContent = "00";
    this.secondsEl.textContent = "00";
  }
}

customElements.define("promotional-countdown-timer", PromotionalCountdownTimer);